// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  box-sizing: border-box;
}

.button {
  padding: 2px;
  cursor: pointer;
  background: linear-gradient(92.28deg, #2042B8 0.63%, #FF6600 109.77%);
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: none;
  outline: none;
}
.button p {
  padding: 1.3vh 3vw;
  color: white;
  font-style: normal;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: bold;
  text-align: center;
  margin: 0;
}
@media screen and (max-width: 767.99px) {
  .button p {
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: bold;
  }
}
@media screen and (max-width: 767.99px) {
  .button {
    min-width: 0;
  }
}
.button.stake-btn {
  width: 80%;
  margin: 0 auto;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  font-weight: 500;
}
.button.secondary {
  box-shadow: none;
}
.button.secondary .btn-inside {
  width: 100%;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.button.secondary .btn-inside p {
  padding: 1.5vh 3vw;
  margin: 0;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: bold;
  background: linear-gradient(44.25deg, #E8433D 25.64%, #FF6600 53.43%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
@media screen and (max-width: 767.99px) {
  .button.secondary .btn-inside p {
    font-size: 0.8rem;
    padding: 1vh 5vh;
  }
}
.button.tertiary {
  border: 2px solid #FFFFFF;
  box-sizing: border-box;
  border-radius: 28px;
  background: transparent;
  background-color: transparent;
  padding: 0;
}
.button.tertiary .btn-inside {
  padding: 0;
  border-radius: 28px;
}
.button.tertiary .btn-inside p {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.125rem;
  font-weight: bold;
  padding: 1.3vh 2vw;
  border-radius: 28px;
  margin: 0;
}
@media screen and (max-width: 767.99px) {
  .button.tertiary .btn-inside p {
    padding: 1vh 2vw;
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 0.6875rem;
    line-height: 0.8125rem;
    font-weight: bold;
  }
}
.button.tertiary.card-btn {
  justify-self: center;
  margin: 0 auto;
}
@media screen and (max-width: 767.99px) {
  .button.tertiary.card-btn {
    width: 100%;
  }
}

.capsule-btn {
  min-width: 18%;
  position: relative;
}
@media screen and (max-width: 767.99px) {
  .capsule-btn {
    min-width: 50%;
  }
}
.capsule-btn .left-capsule {
  background: rgba(255, 255, 255, 0.14);
  color: #FFFFFF;
  width: 60%;
  padding: 1.3vh 1vw 1.3vh 1vw;
  box-sizing: border-box;
  border-radius: 60px;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.8125rem;
  line-height: 1rem;
  font-weight: bold;
  cursor: pointer;
}
@media screen and (max-width: 767.99px) {
  .capsule-btn .left-capsule {
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 0.625rem;
    line-height: 1rem;
    font-weight: bold;
    padding-left: 5%;
  }
}
.capsule-btn .right-capsule {
  background: #5A5F6E;
  color: #FFFFFF;
  width: 55%;
  padding: 1.3vh 1vw 1.3vh 1vw;
  box-sizing: border-box;
  border-radius: 60px;
  z-index: 50;
  position: absolute;
  right: 0;
  top: 0;
  left: 45%;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.8125rem;
  line-height: 1rem;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
}
@media screen and (max-width: 767.99px) {
  .capsule-btn .right-capsule {
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 0.625rem;
    line-height: 1rem;
    font-weight: bold;
  }
}

.connect-wallet {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.connect-wallet .wallet-img {
  margin-right: 1vw;
}

.modal-cont {
  display: block;
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.62);
  overflow-y: scroll;
  box-sizing: border-box;
}
@media screen and (max-width: 767.99px) {
  .modal-cont {
    width: 100%;
  }
}
.modal-cont.hidden {
  display: none;
}
.modal-cont .content-cont {
  min-width: 30%;
  min-height: 45vh;
  max-height: 95vh;
  z-index: 3000;
  background-color: #1C1D21;
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: nill;
  align-items: nill;
  border-radius: 4px;
  overflow-y: auto;
  box-sizing: border-box;
}
@media screen and (max-width: 767.99px) {
  .modal-cont .content-cont {
    min-width: 95%;
    max-width: 100%;
    width: 100%;
    max-height: 75vh;
  }
}
.modal-cont .content-cont .header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5vh;
}
.modal-cont .content-cont .header #modal-title {
  justify-self: flex-start;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.5rem;
  line-height: 1.9375rem;
  font-weight: bold;
}
.modal-cont .content-cont .header #close-modal {
  cursor: pointer;
  justify-self: flex-end;
  padding: 0.5rem;
  border-radius: 6px;
}
.modal-cont .content-cont.stake-modal {
  min-width: 70%;
  border-radius: 22px;
  padding-right: 0;
}

.wallet-form-1 #title-1 {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.5rem;
  line-height: 1.9375rem;
  font-weight: bold;
  margin-bottom: 7vh;
}
.wallet-form-1 .wallet-box {
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0px 17.8125px 18.525px rgba(0, 0, 0, 0.1);
  border-radius: 5.44429px;
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: center;
  margin-bottom: 3vh;
  padding: 1.5vw;
  box-sizing: border-box;
  cursor: pointer;
}
.wallet-form-1 .wallet-box #wallet-img {
  margin-right: 2vw;
  min-width: 5vw;
  min-height: 4vh;
}
.wallet-form-1 .wallet-box .details #wallet {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: bold;
  margin-bottom: 1vh;
}
.wallet-form-1 .wallet-box .details #info {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.8125rem;
  line-height: 1.0625rem;
  font-weight: 600;
}

.wallet-form-2 .wallet-details {
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0px 17.8125px 18.525px rgba(0, 0, 0, 0.1);
  border-radius: 5.44429px;
  padding: 2vw;
  margin-bottom: 5vh;
  box-sizing: border-box;
}
.wallet-form-2 .wallet-details #chain {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.125rem;
  font-weight: 600;
  margin-bottom: 1vh;
}
.wallet-form-2 .wallet-details #value {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: bold;
  margin-bottom: 10vh;
}
.wallet-form-2 .wallet-details #wallet-address {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.125rem;
  font-weight: 600;
  margin-bottom: 1vh;
}
.wallet-form-2 .wallet-details #wallet {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: bold;
}
.wallet-form-2 .btn-cont {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.wallet-form-2 .btn-cont #disconnect-btn {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: bold;
  color: #FF6600;
  margin-bottom: 5vh;
  padding: 0 0.2vw;
  cursor: pointer;
}

nav {
  width: 80%;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 767.99px) {
  nav {
    padding: 0 5%;
    box-sizing: border-box;
  }
}
nav .logo {
  cursor: pointer;
}

.ant-notification {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: fixed;
  z-index: 1010;
  margin-right: 24px;
}

.ant-notification-topLeft,
.ant-notification-bottomLeft {
  margin-right: 0;
  margin-left: 24px;
}

.ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active,
.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active {
  animation-name: NotificationLeftFadeIn;
}

.ant-notification-close-icon {
  font-size: 14px;
  cursor: pointer;
}

.ant-notification-hook-holder {
  position: relative;
}

.ant-notification-notice {
  position: relative;
  width: 384px;
  max-width: calc(100vw - 48px);
  margin-bottom: 16px;
  margin-left: auto;
  padding: 16px 24px;
  overflow: hidden;
  line-height: 1.5715;
  word-wrap: break-word;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-notification-topLeft .ant-notification-notice,
.ant-notification-bottomLeft .ant-notification-notice {
  margin-right: auto;
  margin-left: 0;
}

.ant-notification-notice-message {
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 24px;
}

.ant-notification-notice-message-single-line-auto-margin {
  display: block;
  width: calc(264px - 100%);
  max-width: 4px;
  background-color: transparent;
  pointer-events: none;
}

.ant-notification-notice-message-single-line-auto-margin::before {
  display: block;
  content: "";
}

.ant-notification-notice-description {
  font-size: 14px;
}

.ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 24px;
}

.ant-notification-notice-with-icon .ant-notification-notice-message {
  margin-bottom: 4px;
  margin-left: 48px;
  font-size: 16px;
}

.ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-left: 48px;
  font-size: 14px;
}

.ant-notification-notice-icon {
  position: absolute;
  margin-left: 4px;
  font-size: 24px;
  line-height: 24px;
}

.anticon.ant-notification-notice-icon-success {
  color: #52c41a;
}

.anticon.ant-notification-notice-icon-info {
  color: #1890ff;
}

.anticon.ant-notification-notice-icon-warning {
  color: #faad14;
}

.anticon.ant-notification-notice-icon-error {
  color: #ff4d4f;
}

.ant-notification-notice-close {
  position: absolute;
  top: 16px;
  right: 22px;
  color: rgba(0, 0, 0, 0.45);
  outline: none;
}

.ant-notification-notice-close:hover {
  color: rgba(0, 0, 0, 0.67);
}

.ant-notification-notice-btn {
  float: right;
  margin-top: 16px;
}

.ant-notification .notification-fade-effect {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
}

.ant-notification-fade-enter,
.ant-notification-fade-appear {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
  opacity: 0;
  animation-play-state: paused;
}

.ant-notification-fade-leave {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
  animation-duration: 0.2s;
  animation-play-state: paused;
}

.ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-fade-appear.ant-notification-fade-appear-active {
  animation-name: NotificationFadeIn;
  animation-play-state: running;
}

.ant-notification-fade-leave.ant-notification-fade-leave-active {
  animation-name: NotificationFadeOut;
  animation-play-state: running;
}
@keyframes NotificationFadeIn {
  0% {
    left: 384px;
    opacity: 0;
  }
  100% {
    left: 0;
    opacity: 1;
  }
}
@keyframes NotificationLeftFadeIn {
  0% {
    right: 384px;
    opacity: 0;
  }
  100% {
    right: 0;
    opacity: 1;
  }
}
@keyframes NotificationFadeOut {
  0% {
    max-height: 150px;
    margin-bottom: 16px;
    opacity: 1;
  }
  100% {
    max-height: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    opacity: 0;
  }
}
.ant-notification-rtl {
  direction: rtl;
}

.ant-notification-rtl .ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 0;
  padding-left: 24px;
}

.ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-message {
  margin-right: 48px;
  margin-left: 0;
}

.ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-right: 48px;
  margin-left: 0;
}

.ant-notification-rtl .ant-notification-notice-icon {
  margin-right: 4px;
  margin-left: 0;
}

.ant-notification-rtl .ant-notification-notice-close {
  right: auto;
  left: 22px;
}

.ant-notification-rtl .ant-notification-notice-btn {
  float: left;
}

.home {
  position: relative;
  padding: 3% 5% 0 5%;
}
.home .home-main {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: nill;
  align-items: center;
  box-sizing: border-box;
}
@media screen and (max-width: 767.99px) {
  .home .home-main {
    padding: 5%;
  }
}
.home .home-main .step-1 {
  width: 92%;
  margin-top: 5%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 767.99px) {
  .home .home-main .step-1 {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: nill;
    align-items: flex-start;
    margin-bottom: 8vh;
  }
}
.home .home-main .step-1 #topic {
  width: 28%;
  margin-left: 2.5%;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 2rem;
  line-height: 3.125rem;
  font-weight: 800;
}
@media screen and (max-width: 767.99px) {
  .home .home-main .step-1 #topic {
    width: 100%;
    margin: 0 0 5vh 0;
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 1.5rem;
    line-height: 1.875rem;
    font-weight: 800;
    text-align: center;
  }
}
.home .home-main .step-1 .locker {
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0px 14px 40px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 1.5vh 2vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}
@media screen and (max-width: 767.99px) {
  .home .home-main .step-1 .locker {
    width: 80%;
    margin: 0 auto;
  }
}
.home .home-main .step-1 .locker .lock-left {
  margin-right: 3.5vw;
}
.home .home-main .step-1 .locker .lock-left #title {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  font-weight: bold;
  margin-bottom: 1.5vh;
}
.home .home-main .step-1 .locker .lock-left #value {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.5rem;
  line-height: 1.875rem;
  font-weight: 600;
}
.home .home-main .step-2 {
  width: 92%;
  margin-top: 5%;
  padding: 2vw;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0px 14px 40px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
@media screen and (max-width: 767.99px) {
  .home .home-main .step-2 {
    width: 100%;
    margin-bottom: 8vh;
    padding: 5vw;
    box-sizing: border-box;
  }
}
.home .home-main .step-2 #connect {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.5rem;
  line-height: 1.875rem;
  font-weight: 500;
  text-align: center;
}
.home .home-main .step-2 #dets {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.875rem;
  font-weight: 500;
  text-align: center;
  color: #8E93A4;
}
.home .home-main .step-2 .non-empty {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 767.99px) {
  .home .home-main .step-2 .non-empty {
    display: flex;
    flex-direction: column;
    justify-content: nill;
    align-items: flex-start;
  }
}
.home .home-main .step-2 .non-empty .left-2 {
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: center;
}
@media screen and (max-width: 767.99px) {
  .home .home-main .step-2 .non-empty .left-2 {
    display: flex;
    flex-direction: column;
    justify-content: nill;
    align-items: flex-start;
    margin-bottom: 5vh;
  }
}
.home .home-main .step-2 .non-empty .left-2 .box-2 {
  margin-right: 5vw;
}
@media screen and (max-width: 767.99px) {
  .home .home-main .step-2 .non-empty .left-2 .box-2 {
    margin: 0 0 5vh 0;
  }
}
.home .home-main .step-2 .non-empty .left-2 .box-2 .prop {
  color: #8E93A4;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  margin-bottom: 2vh;
}
@media screen and (max-width: 767.99px) {
  .home .home-main .step-2 .non-empty .left-2 .box-2 .prop {
    margin-bottom: 1vh;
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 0.75rem;
    line-height: 1.25rem;
    font-weight: 500;
  }
}
.home .home-main .step-2 .non-empty .left-2 .box-2 .val {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.5rem;
  line-height: 1.875rem;
  font-weight: bold;
}
@media screen and (max-width: 767.99px) {
  .home .home-main .step-2 .non-empty .left-2 .box-2 .val {
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 1.125rem;
    line-height: 1.5625rem;
    font-weight: bold;
  }
}
.home .home-main .step-2 .non-empty .left-2 .box-2 .amount {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
}
@media screen and (max-width: 767.99px) {
  .home .home-main .step-2 .non-empty .left-2 .box-2 .amount {
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 0.75rem;
    line-height: 1.25rem;
    font-weight: 500;
  }
}
.home .home-main .step-2 .non-empty .right-2 {
  align-self: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: center;
}
@media screen and (max-width: 767.99px) {
  .home .home-main .step-2 .non-empty .right-2 {
    align-self: flex-start;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
.home .home-main .step-2 .non-empty .right-2 .pointer {
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: center;
  cursor: pointer;
  margin-right: 2.5vw;
}
.home .home-main .step-2 .non-empty .right-2 .pointer .label {
  margin-right: 0.5vw;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
}
.home .home-main .step-3 {
  width: 92%;
  height: auto;
  margin-top: 5%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 767.99px) {
  .home .home-main .step-3 {
    display: flex;
    flex-direction: column;
    justify-content: nill;
    align-items: flex-start;
  }
}

.package-card {
  width: 31%;
  min-height: 30vh;
  border-radius: 8px;
  padding: 2.5%;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0px 14px 40px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
@media screen and (max-width: 767.99px) {
  .package-card {
    width: 100%;
    padding: 5%;
    margin-bottom: 5vh;
  }
}
.package-card .card-type-desc {
  font-family: Fira Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 143%;
  display: flex;
  align-items: center;
  color: #8E93A4;
}
.package-card .card-type {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.25rem;
  font-weight: 500;
  margin-bottom: 2.5vh;
  font-family: Fira Sans;
  font-style: normal;
  font-weight: 500;
}
@media screen and (max-width: 767.99px) {
  .package-card .card-type {
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 0.9375rem;
    line-height: 1.25rem;
    font-weight: 500;
  }
}
.package-card .card-apy {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 5.0625rem;
  line-height: 5.625rem;
  font-weight: 600;
  margin-bottom: 10%;
}
@media screen and (max-width: 767.99px) {
  .package-card .card-apy {
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 3.125rem;
    line-height: 4.375rem;
    font-weight: 600;
  }
}
.package-card .card-apy #apy {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.25rem;
  font-weight: 500;
}
@media screen and (max-width: 767.99px) {
  .package-card .card-apy #apy {
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 0.9375rem;
    line-height: 1.25rem;
    font-weight: 500;
  }
}

.containerBanner {
  position: relative;
  text-align: center;
}

.top-left-banner {
  position: absolute;
  top: 10vh;
  left: 8vw;
  font-family: Fira Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 18.4612px;
  line-height: 143%;
  /* or 26px */
  color: #FDFDFD;
}

@media only screen and (min-width: 600px) {
  .banner-img {
    width: 60vw;
  }
}
@media screen and (max-width: 400px) {
  .banner-img {
    width: 82vw;
  }
}
@media screen and (max-width: 768px) {
  .banner-img {
    width: 80vw;
  }
}

.centered-banner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
@media only screen and (min-width: 600px) {
  .centered-banner {
    position: absolute;
    top: 20vh;
    left: 53vw;
    transform: translate(-50%, -50%);
    background-color: #E46D28;
  }
}
@media screen and (min-height: 812px) and (max-width: 813px) {
  .centered-banner {
    position: absolute;
    top: 10vh;
    left: 71vw;
    transform: translate(-50%, -50%);
    background-color: #E46D28;
    height: 14px;
  }
}
@media screen and (min-width: 375px) and (max-width: 376px) {
  .centered-banner {
    position: absolute;
    top: 7vh;
    left: 71vw;
    transform: translate(-50%, -50%);
    background-color: #E46D28;
    height: 23px;
  }
}
@media screen and (min-width: 414px) and (max-width: 415px) {
  .centered-banner {
    position: absolute;
    top: 7vh;
    left: 71vw;
    transform: translate(-50%, -50%);
    background-color: #E46D28;
    height: 14px;
  }
}
@media screen and (min-width: 411px) and (max-width: 412px) {
  .centered-banner {
    position: absolute;
    top: 7vh;
    left: 71vw;
    transform: translate(-50%, -50%);
    background-color: #E46D28;
    height: 14px;
  }
}
@media screen and (max-width: 360px) {
  .centered-banner {
    position: absolute;
    top: 7vh;
    left: 72vw;
    transform: translate(-50%, -50%);
    background-color: #E46D28;
    height: 14px;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
  .centered-banner {
    position: absolute;
    top: 8vh;
    left: 53vw;
    transform: translate(-50%, -50%);
    background-color: #E46D28;
  }
}

@media only screen and (min-width: 600px) {
  .arrowClassBanner {
    height: 3vh;
  }
}
@media screen and (min-width: 375px) and (max-width: 400px) {
  .arrowClassBanner {
    height: 1vh;
  }
}
@media screen and (min-width: 360px) and (max-width: 361px) {
  .arrowClassBanner {
    height: 2vh;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
  .arrowClassBanner {
    height: 2vh;
  }
}

.bottom-right-banner {
  position: absolute;
  bottom: 20vh;
  right: 14vw;
  font-family: Fira Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 18.4612px;
  line-height: 143%;
  width: 10vw;
  color: #FFFFFF;
  width: 200px;
  height: 57px;
  /* or 19px */
  color: #FFFFFF;
}

footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding: 5% 5% 2% 5%;
  box-sizing: border-box;
}
@media screen and (max-width: 767.99px) {
  footer {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 0.5vh;
  }
}
footer #copy {
  order: 1;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.75rem;
  line-height: 0.875rem;
  font-weight: 500;
  color: #D1D1D1;
}
@media screen and (max-width: 767.99px) {
  footer #copy {
    order: 2;
  }
}
footer .foot-menu {
  order: 2;
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
}
@media screen and (max-width: 767.99px) {
  footer .foot-menu {
    order: 1;
  }
}
footer .foot-menu .foot-list {
  margin: 0 2vw 1vh 0;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  font-weight: 500;
  cursor: pointer;
}

.table-cont {
  box-shadow: 0px 0px 17px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  position: relative;
}
.table-cont .table-scroll {
  position: relative;
}
@media screen and (max-width: 767.99px) {
  .table-cont .table-scroll {
    overflow: auto;
  }
}
.table-cont table {
  width: 100%;
  position: relative;
  padding: 1rem;
  border-collapse: collapse;
}
.table-cont table thead {
  height: 4.06rem;
  z-index: 100;
}
.table-cont table thead tr {
  height: 10vh;
}
.table-cont table thead tr th {
  font-weight: 500;
  margin-bottom: 10rem;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: bold;
}
.table-cont table tbody {
  overflow: scroll;
  margin-top: 30vh;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0px 14px 40px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  min-height: 50vh;
}
.table-cont table tbody tr {
  height: 10vh;
  border-bottom: 1px solid rgba(102, 102, 102, 0.91);
  padding: 0.2vh 0;
}
.table-cont table tbody tr:last-child {
  border-bottom: none;
}
.table-cont table tbody td {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: bold;
}
.table-cont table th {
  text-align: left;
  padding-left: 2.81rem;
}
.table-cont table td {
  padding-left: 2.81rem;
}
@media screen and (max-width: 576px) {
  .table-cont table th {
    padding: 0.937rem;
    white-space: nowrap;
  }
  .table-cont table td {
    padding: 0.937rem;
    white-space: nowrap;
  }
}
.table-cont .empty-cont {
  min-height: 40vh;
  padding: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(48, 47, 47, 0.14);
  color: #FF6600;
  box-sizing: border-box;
}
.table-cont .pagination {
  background-color: #fff;
  padding: 2rem 3rem;
  display: flex;
  justify-content: flex-end;
  overflow-x: scroll;
}
.table-cont .pagination .pages {
  overflow-x: scroll;
}
.table-cont .pagination .pages .page {
  margin: 0 0.09rem;
  border-radius: 2px;
  text-align: center;
  padding: 0.15rem 0.3rem;
  color: #c7c7c7;
  border: 1px solid pink;
}
.table-cont .pagination .pages .page.ellipse {
  margin: 0;
  border: 0;
  padding: 0.15rem 0;
}
.table-cont .pagination .pages .page.active {
  background-color: pink;
  color: #fff;
}
.table-cont .pagination .pages img {
  cursor: pointer;
}

#table-user {
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: center;
  text-transform: capitalize;
  padding: 0.7vh;
}
#table-user img {
  margin-right: 0.5vw;
}

#red-status {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: 500;
  text-transform: capitalize;
  color: #E8433D;
}

#green-status {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: 500;
  text-transform: capitalize;
  color: #23A65A;
}

.transactions {
  padding: 3% 5% 0 5%;
}
.transactions .transaction-main {
  margin-top: 5vh;
}
.transactions .transaction-main .header {
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: center;
}
.transactions .transaction-main .header .back-img {
  margin-right: 1.5vw;
  cursor: pointer;
}
@media screen and (max-width: 767.99px) {
  .transactions .transaction-main .header .back-img {
    margin-right: 3vw;
  }
}
.transactions .transaction-main .header .page-dets #topic {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.5rem;
  line-height: 1.875rem;
  font-weight: 800;
}
@media screen and (max-width: 767.99px) {
  .transactions .transaction-main .header .page-dets #topic {
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 1.125rem;
    line-height: 1.25rem;
    font-weight: 800;
  }
}
.transactions .transaction-main .header .page-dets #sub-topic {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  font-weight: 500;
}
@media screen and (max-width: 767.99px) {
  .transactions .transaction-main .header .page-dets #sub-topic {
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 0.75rem;
    line-height: 0.9375rem;
    font-weight: 500;
  }
}
.transactions .transaction-main .table-section {
  margin-top: 5vh;
}

.filter.stake-filter {
  margin-top: 5vh;
}
.filter .label {
  width: 100%;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  margin: 0 0 0.5rem 0;
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: flex-start;
}
.filter .label .asterik {
  display: block;
  margin-left: 0.2vw;
  color: #FF6600;
}
.filter .label .hide {
  display: none;
}
.filter .select {
  width: 100%;
  padding: 0 1.5vw;
  display: flex;
  justify-content: center;
  height: 2.8rem;
  outline: none;
  box-sizing: border-box;
  border-radius: 7px;
  font-style: normal;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  font-weight: normal;
  cursor: pointer;
  background-color: transparent;
  color: #F9F9F9;
}
.filter.ship-filter-long {
  width: 100%;
  margin-bottom: 1.5rem;
}
.filter.ship-filter-long .select {
  border: 1px solid #707070;
  height: 3rem;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: bold;
  color: #6D6D6D;
  background: none;
  -webkit-background-clip: text;
  -webkit-text-fill-color: #6D6D6D;
}

.input-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: nill;
  align-items: nill;
  margin-bottom: 1rem;
}
.input-box.stake-input {
  margin-top: 5vh;
}
.input-box.stake-type {
  margin-top: 5vh;
}
.input-box .head-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.input-box .head-box .label-box {
  justify-self: flex-start;
  width: 100%;
}
.input-box .head-box .label-box .label {
  width: 100%;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  margin: 0 0 0.5rem 0;
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: flex-start;
}
.input-box .head-box .label-box .label .asterik {
  display: block;
  margin-left: 0.2vw;
  color: #FF6600;
}
.input-box .head-box .label-box .label .hide {
  display: none;
}
.input-box .head-box .label-box .sub-label {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.8125rem;
  line-height: 1.0625rem;
  font-weight: 500;
  margin-bottom: 0.4rem;
}
.input-box .head-box .input-right {
  justify-self: flex-end;
}
.input-box .input-cont {
  width: 100%;
  border: 1px solid #707070;
  box-sizing: border-box;
  border-radius: 7px;
  height: 3rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
@media screen and (max-width: 767.99px) {
  .input-box .input-cont {
    height: 3rem;
  }
}
.input-box .input-cont .input {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: center;
  height: 100%;
  border: none;
  box-sizing: border-box;
  border-radius: 60px;
  padding: 0 5%;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  font-weight: normal;
  display: flex;
  align-items: center;
  outline: none;
  background: transparent;
  color: #FFFFFF;
}
@media screen and (max-width: 767.99px) {
  .input-box .input-cont .input {
    width: 100%;
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 0.9375rem;
    line-height: 1.3125rem;
    font-weight: bold;
  }
}
.input-box .input-cont .input.stake-type {
  text-align: center;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.375rem;
  font-weight: normal;
}
.input-box .input-cont .suffix {
  width: 35%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-left: 0.5px solid #6D6D6D;
}
@media screen and (max-width: 767.99px) {
  .input-box .input-cont .suffix {
    width: 45%;
  }
}
.input-box .input-cont.step-input {
  border: 2px solid #FF6600;
}
.input-box .input-cont.step-input input {
  width: 65%;
  color: #1F1F20;
}
.input-box .input-cont.step-input .suffix {
  width: 35%;
}
@media screen and (max-width: 767.99px) {
  .input-box .input-cont.step-input .input-cont input {
    width: 60%;
  }
  .input-box .input-cont.step-input .input-cont .suffix {
    width: 40%;
  }
}
.input-box .label-cont {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 2vw;
  box-sizing: border-box;
  width: 100%;
}
.input-box .label-cont #label-text {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: bold;
}
@media screen and (max-width: 767.99px) {
  .input-box .label-cont #label-text {
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: bold;
  }
}
.input-box .label-cont .label-right {
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: center;
}
.input-box .label-cont .label-right p {
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: center;
}
.input-box .label-cont .label-right p #available {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.75rem;
  line-height: 1.25rem;
  font-weight: normal;
}
.input-box .label-cont .label-right p #coin {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.75rem;
  line-height: 1.25rem;
  font-weight: bold;
  margin-left: 0.3vw;
}
.input-box .label-cont .label-right p #max {
  background: #f3dbca;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: bold;
  color: #FF6600;
  padding: 0.6vw 0.5vw;
  border-radius: 100px;
  margin-left: 1vw;
  cursor: pointer;
}
.input-box .trasnaction-suffix {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.input-box .trasnaction-suffix #arrow {
  cursor: pointer;
}
.input-box .step-suffix {
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
@media screen and (max-width: 767.99px) {
  .input-box .step-suffix {
    width: 90%;
  }
}
@media screen and (max-width: 767.99px) {
  .input-box .step-suffix #coin {
    width: 3vw;
    height: 3vh;
  }
}
.input-box .step-suffix #currency {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.9375rem;
  line-height: 1.4375rem;
  font-weight: bold;
}
@media screen and (max-width: 767.99px) {
  .input-box .step-suffix #currency {
    font-family: "Fira Sans", sans-serif;
    font-style: normal;
    font-size: 0.75rem;
    line-height: 1.25rem;
    font-weight: bold;
  }
}

.input-label {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.input-label #label-right {
  color: #B1AFCD;
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 500;
}
.input-label #label-right #suffix-span {
  margin-left: 0.5vw;
}

.staking {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: nill;
}
@media screen and (max-width: 767.99px) {
  .staking {
    flex-direction: column;
  }
}
.staking .stake-title {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 1.375rem;
  font-weight: 500;
  margin-bottom: 5vh;
}
.staking .stake-left {
  width: 50%;
  border-right: 1px solid rgba(216, 216, 216, 0.05);
}
@media screen and (max-width: 767.99px) {
  .staking .stake-left {
    width: 100%;
    padding: 5%;
    box-sizing: border-box;
    border-right: none;
  }
}
.staking .stake-left .left-main {
  padding: 1.5vw 2vw;
  box-sizing: border-box;
}
.staking .percentages {
  margin: 1.5rem 20% 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.staking .activeValueSelection {
  border: 2px solid rgb(255, 102, 0);
  border-radius: 40.8111px;
  padding: 0.3rem 0.7rem;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: rgb(255, 102, 0);
}
.staking .notActiveValueSelection {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: rgb(255, 102, 0);
  cursor: pointer;
}
.staking .stake-right {
  width: 50%;
  padding: 1.5vw 2vw 3vw 2vw;
  box-sizing: border-box;
}
@media screen and (max-width: 767.99px) {
  .staking .stake-right {
    width: 100%;
    padding: 5%;
    box-sizing: border-box;
  }
}
.staking .stake-right .box {
  margin-top: 3vh;
  min-height: 20vh;
  margin-bottom: 3vh;
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: nill;
}
.staking .stake-right .box .rings {
  margin-right: 1vw;
}
.staking .stake-right .box .items-main {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: nill;
}
.staking .stake-right .box .items-main .row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.staking .stake-right .box .items-main .row .item {
  color: #B1AFCD;
}
.staking .stake-right .box .items-main .row .val {
  color: rgba(177, 175, 205, 0.5);
}
.staking .stake-right .row-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3vh;
}
.staking .stake-right .row-box #item {
  color: #B1AFCD;
}
.staking .stake-right .row-box #val {
  color: #16AB5B;
}
.staking .stake-right .check {
  display: flex;
  flex-direction: row;
  justify-content: nill;
  align-items: center;
  margin: 5vh 0;
}
.staking .stake-right .check .check-img {
  margin-right: 1vw;
}
.staking .stake-right .check #agree {
  color: rgba(177, 175, 205, 0.5);
}

.ant-notification {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: fixed;
  z-index: 1010;
  margin-right: 24px;
}

.ant-notification-topLeft,
.ant-notification-bottomLeft {
  margin-right: 0;
  margin-left: 24px;
}

.ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active,
.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active {
  animation-name: NotificationLeftFadeIn;
}

.ant-notification-close-icon {
  font-size: 14px;
  cursor: pointer;
}

.ant-notification-hook-holder {
  position: relative;
}

.ant-notification-notice {
  position: relative;
  width: 384px;
  max-width: calc(100vw - 48px);
  margin-bottom: 16px;
  margin-left: auto;
  padding: 16px 24px;
  overflow: hidden;
  line-height: 1.5715;
  word-wrap: break-word;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-notification-topLeft .ant-notification-notice,
.ant-notification-bottomLeft .ant-notification-notice {
  margin-right: auto;
  margin-left: 0;
}

.ant-notification-notice-message {
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 24px;
}

.ant-notification-notice-message-single-line-auto-margin {
  display: block;
  width: calc(264px - 100%);
  max-width: 4px;
  background-color: transparent;
  pointer-events: none;
}

.ant-notification-notice-message-single-line-auto-margin::before {
  display: block;
  content: "";
}

.ant-notification-notice-description {
  font-size: 14px;
}

.ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 24px;
}

.ant-notification-notice-with-icon .ant-notification-notice-message {
  margin-bottom: 4px;
  margin-left: 48px;
  font-size: 16px;
}

.ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-left: 48px;
  font-size: 14px;
}

.ant-notification-notice-icon {
  position: absolute;
  margin-left: 4px;
  font-size: 24px;
  line-height: 24px;
}

.anticon.ant-notification-notice-icon-success {
  color: #52c41a;
}

.anticon.ant-notification-notice-icon-info {
  color: #1890ff;
}

.anticon.ant-notification-notice-icon-warning {
  color: #faad14;
}

.anticon.ant-notification-notice-icon-error {
  color: #ff4d4f;
}

.ant-notification-notice-close {
  position: absolute;
  top: 16px;
  right: 22px;
  color: rgba(0, 0, 0, 0.45);
  outline: none;
}

.ant-notification-notice-close:hover {
  color: rgba(0, 0, 0, 0.67);
}

.ant-notification-notice-btn {
  float: right;
  margin-top: 16px;
}

.ant-notification .notification-fade-effect {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
}

.ant-notification-fade-enter,
.ant-notification-fade-appear {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
  opacity: 0;
  animation-play-state: paused;
}

.ant-notification-fade-leave {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
  animation-duration: 0.2s;
  animation-play-state: paused;
}

.ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-fade-appear.ant-notification-fade-appear-active {
  animation-name: NotificationFadeIn;
  animation-play-state: running;
}

.ant-notification-fade-leave.ant-notification-fade-leave-active {
  animation-name: NotificationFadeOut;
  animation-play-state: running;
}
@keyframes NotificationFadeIn {
  0% {
    left: 384px;
    opacity: 0;
  }
  100% {
    left: 0;
    opacity: 1;
  }
}
@keyframes NotificationLeftFadeIn {
  0% {
    right: 384px;
    opacity: 0;
  }
  100% {
    right: 0;
    opacity: 1;
  }
}
@keyframes NotificationFadeOut {
  0% {
    max-height: 150px;
    margin-bottom: 16px;
    opacity: 1;
  }
  100% {
    max-height: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    opacity: 0;
  }
}
.ant-notification-rtl {
  direction: rtl;
}

.ant-notification-rtl .ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 0;
  padding-left: 24px;
}

.ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-message {
  margin-right: 48px;
  margin-left: 0;
}

.ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-right: 48px;
  margin-left: 0;
}

.ant-notification-rtl .ant-notification-notice-icon {
  margin-right: 4px;
  margin-left: 0;
}

.ant-notification-rtl .ant-notification-notice-close {
  right: auto;
  left: 22px;
}

.ant-notification-rtl .ant-notification-notice-btn {
  float: left;
}

.AddressContainer {
  display: flex;
  align-items: center;
}
.AddressContainer > div {
  border: 1px solid rgba(241, 237, 237, 0.6);
  box-sizing: border-box;
  flex-grow: 1;
  border-radius: 34px;
  padding: 16px;
  display: flex;
  margin-right: 16px;
  overflow-x: auto;
  justify-content: center;
  align-items: center;
}
.AddressContainer > div > p {
  margin: 0;
  color: rgba(241, 237, 237, 0.6);
}

.ConnectInfoWrapper {
  display: flex;
  margin-bottom: 60px;
}
.ConnectInfoWrapper > div {
  height: 48px;
  display: flex;
  flex-direction: column;
  flex: auto;
  justify-content: space-between;
}

.InfoWrapper {
  padding: 28px;
  background: #27282C;
  border-radius: 6px;
  color: #edecec;
  font-size: 20px;
  font-weight: 600;
  line-height: 138%;
}

.SectionWrapper {
  margin-top: 40px;
}

.SectionBodyNetwork {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}
@media (min-width: 768px) {
  .SectionBodyNetwork {
    flex-direction: row;
  }
}

.CardWrapper {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
  margin-right: 10px;
  height: 90px;
  font-size: 18px;
  font-weight: 500;
  background: #27282C;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  box-shadow: 0px 3.51724px 36.0517px rgba(0, 0, 0, 0.06);
  border-radius: 14.7847px;
  padding: 16px;
}
.CardWrapper:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background: #edecec;
}
@media (min-width: 768px) {
  .CardWrapper {
    width: 33%;
  }
}
.CardWrapper .chain-name {
  margin-left: 16px;
  color: #edecec;
}
.CardWrapper .apy {
  color: #edecec;
  font-size: 14px;
  font-weight: 600;
}
.CardWrapper .check {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(30%, -30%);
}

.SectionHeader {
  display: flex;
  margin: 16px 0px;
  align-items: center;
}
.SectionHeader .number {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 26px;
  width: 26px;
  background: rgba(0, 0, 0, 0.06);
  color: #edecec;
  font-weight: 600;
  font-size: 18px;
  border-radius: 50%;
  color: #edecec;
}
.SectionHeader .modal-title {
  font-weight: 600;
  font-size: 18px;
  margin-left: 20px;
  color: #edecec;
}

.ModalControls {
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 20px;
  margin-bottom: 5vw;
}
.ModalControls .heading {
  font-weight: 600;
  font-size: 1.5rem;
  margin-bottom: 5px;
  text-transform: capitalize;
  color: #edecec;
}
.ModalControls .desc {
  font-size: 1rem;
  color: #edecec;
}
.ModalControls > div:first-child {
  flex: 1 1;
  color: #edecec;
}
.ModalControls button.close {
  border: none;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #5e5656 !important;
  cursor: pointer;
}
.ModalControls .close-btn {
  color: #edecec;
}

.ConnectWalletStyle {
  border: none;
  margin-left: 15px;
  display: flex;
  align-items: center;
  background: linear-gradient(100.89deg, #363535 3.11%, #9d9c9c 122.62%);
  min-width: max-content;
  max-height: 46px;
  border-radius: 38px;
  color: white;
  padding: 10px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}
.ConnectWalletStyle > div {
  display: inline-flex;
  align-items: center;
}
.ConnectWalletStyle .wallet {
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  padding: 0px;
  border-radius: 52px;
  margin-left: 10px;
}
.ConnectWalletStyle figure {
  margin-right: 7px;
  background: transparent;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.ConnectWalletStyle figure svg {
  width: 18px;
}
.ConnectWalletStyle figure.connected {
  background: white;
}
.ConnectWalletStyle figure.connectedNetwork {
  background: white;
  width: 40px;
  height: 40px;
}
@media (min-width: 900px) {
  .ConnectWalletStyle {
    padding: 10px;
    background: linear-gradient(100.89deg, #363535 3.11%, #9d9c9c 122.62%);
    font-size: 14px;
  }
  .ConnectWalletStyle .wallet figure img {
    width: 18px;
  }
}
@media (min-width: 300px) {
  .ConnectWalletStyle {
    padding: 10px;
    background: linear-gradient(100.89deg, #363535 3.11%, #9d9c9c 122.62%);
    font-size: 14px;
  }
  .ConnectWalletStyle .wallet figure img {
    width: 18px;
  }
}

.CardContainer {
  margin-top: 32px;
  border: 1px solid rgba(241, 237, 237, 0.6);
  box-sizing: border-box;
  box-shadow: 0px 3.51724px 36.0517px rgba(0, 0, 0, 0.06);
  border-radius: 14.7847px;
  padding: 24px;
}

.AddressInfoWrapper {
  margin: 8px 0;
}
.AddressInfoWrapper p {
  margin-bottom: 16px;
}

.ActionContainer {
  display: flex;
  flex-direction: column;
  padding: 20px;
}
.ActionContainer div {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.ActionContainer div p {
  margin-left: 8px;
}
@media (min-width: 768px) {
  .ActionContainer {
    flex-direction: row;
    justify-content: space-between;
  }
}

.modal-cont-connect {
  position: relative;
  overflow-y: auto;
  padding: 30px;
  width: 100%;
  margin: auto;
  /* margin-top: 100px; */
  border-radius: 30px;
  min-height: 50vh;
  /* opacity: 0; */
  transform: scale(0.8);
  transition: all 300ms ease;
  /* background:#1C1D21; */
  box-sizing: border-box;
}
@media only screen and (min-width: 600px) {
  .modal-cont-connect {
    max-width: 50vw;
  }
}
@media screen and (max-width: 350px) {
  .modal-cont-connect {
    max-width: 75vw;
  }
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Fira Sans", sans-serif;
  background: #070E17;
  color: #ffffff;
}
body p {
  margin: 0;
}

.modal-styles {
  display: none;
  width: 100%;
  max-width: 600;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 10;
}

.modal-styles.open {
  display: block;
}

.modal-body {
  width: 100%;
  height: 100%;
  opacity: 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.7);
  transition: all 500ms ease-in-out;
}

.modal-body.show {
  opacity: 1;
}

.modal-body > div {
  display: flex;
  justify-content: center;
  padding-top: 120px;
}

.modal-content {
  position: relative;
  border-radius: 20px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1843137255);
  padding: 30px;
  width: 90%;
  background-color: #070E17;
  /* min-height: 100vh; */
  /* bottom: -100vh; */
  transition: all 500ms ease-in-out;
}

.modal-content.open {
  bottom: 0;
}

.modal-content .title {
  font-size: 18px;
}

.close-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

@media (min-width: 768px) {
  .modal-body > div {
    align-items: center;
  }
  .modal-content {
    max-width: 25%;
    /* min-height: 300px; */
    /* bottom: -10vh; */
  }
}
.t-center {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/App.scss","webpack://./src/styles/index.scss","webpack://./src/styles/button.scss","webpack://./src/styles/mixins.scss","webpack://./src/styles/screens.scss","webpack://./src/styles/modal.scss","webpack://./src/styles/navbar.scss","webpack://./src/styles/home.scss","webpack://./src/styles/partials.scss","webpack://./src/styles/table.scss","webpack://./src/styles/transaction.scss","webpack://./src/styles/filter.scss","webpack://./src/styles/input.scss","webpack://./src/styles/staking.scss","webpack://./src/styles/notifier.scss","webpack://./src/styles/connectionModal.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EAEA,sBAAA;ACAF;;ACHA;EACE,YAAA;EACA,eAAA;EACA,qEAAA;EACA,mBAAA;ECJD,aAAA;EACA,sBDIe;ECHf,uBDGuB;ECFvB,mBDE+B;EAC9B,YAAA;EACA,aAAA;ADSF;ACNE;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;ECNH,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBDG0B;EACvB,kBAAA;EACA,SAAA;ADYJ;AGRE;EFVA;ICHD,oCAAA;IACA,kBAAA;IACA,mBAAA;IACA,oBAAA;IACA,iBDO4B;EDkB3B;AACF;AGjBE;EFpBF;IAsBI,YAAA;EDmBF;AACF;AClBE;EACE,UAAA;EACA,cAAA;ECnBH,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBDgB0B;ADwB3B;ACpBE;EACE,gBAAA;ADsBJ;ACnBI;EACE,WAAA;EAEA,mBAAA;ECtCL,aAAA;EACA,sBDsCmB;ECrCnB,uBDqC2B;ECpC3B,mBDoCmC;ADuBpC;ACtBM;EACE,kBAAA;EACA,SAAA;ECnCP,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBDgC8B;EACvB,qEAAA;EACA,6BAAA;EACA,oCAAA;AD4BR;AGtDE;EFoBI;IAQI,iBAAA;IACA,gBAAA;ED8BR;AACF;ACxBE;EACE,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;AD0BJ;ACzBI;EAEE,UAAA;EACA,mBAAA;AD0BN;ACzBM;EC5DL,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBDyD8B;EAGvB,kBAAA;EAEA,mBAAA;EACA,SAAA;AD4BR;AGlFE;EF2DM;IACE,gBAAA;ICzET,oCAAA;IACA,kBAAA;IACA,oBAAA;IACA,sBAAA;IACA,iBDsEgC;ED8B/B;AACF;AC3BI;EACE,oBAAA;EACA,cAAA;AD6BN;AGhGE;EFiEE;IAII,WAAA;ED+BN;AACF;;ACzBA;EAEE,cAAA;EACA,kBAAA;AD2BF;AG1GE;EF4EF;IAKI,cAAA;ED6BF;AACF;AC3BE;EAEE,qCAAA;EACA,cAAA;EAEA,UAAA;EACA,4BAAA;EACA,sBAAA;EACA,mBAAA;ECzGH,oCAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBDsG0B;EACvB,eAAA;AD+BJ;AG7HE;EFoFA;ICjGD,oCAAA;IACA,kBAAA;IACA,mBAAA;IACA,iBAAA;IACA,iBDyG4B;IACvB,gBAAA;EDqCJ;AACF;ACnCE;EACE,mBAAA;EACA,cAAA;EAEA,UAAA;EACA,4BAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EC7HH,oCAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBD0H0B;EACvB,eAAA;EACA,kBAAA;ADwCJ;AG3JE;EFoGA;ICjHD,oCAAA;IACA,kBAAA;IACA,mBAAA;IACA,iBAAA;IACA,iBD8H4B;ED8C3B;AACF;;ACxCA;EChJC,aAAA;EACA,mBDgJe;EC/If,8BD+IoB;EC9IpB,mBD8ImC;AD8CpC;AC7CE;EACE,iBAAA;AD+CJ;;AIpMA;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EFDH,aAAA;EACA,sBECiB;EFAjB,uBAAA;EACA,mBEDiC;EAC9B,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,qCAAA;EAEA,kBAAA;EACA,sBAAA;AJyMJ;AG/LE;ECtBF;IAcM,WAAA;EJ2MJ;AACF;AIzMI;EACE,aAAA;AJ2MN;AIxMI;EACE,cAAA;EAEA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;EF1BL,aAAA;EACA,sBE0BmB;EFzBnB,qBEyB2B;EFxB3B,iBEwBiC;EAE5B,kBAAA;EACA,gBAAA;EACA,sBAAA;AJ2MN;AGtNE;ECDE;IAeI,cAAA;IACA,eAAA;IACA,WAAA;IACA,gBAAA;EJ4MN;AACF;AI3MM;EFvCL,aAAA;EACA,mBEuCqB;EFtCrB,8BEsC0B;EFrC1B,mBEqCyC;EAClC,kBAAA;AJgNR;AI/MQ;EACE,wBAAA;EFpCT,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBEiCgC;AJqNjC;AInNQ;EAGE,eAAA;EACA,sBAAA;EAEA,eAAA;EACA,kBAAA;AJkNV;AI/MM;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AJiNR;;AIvME;EF9DD,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBE2D4B;EACvB,kBAAA;AJ8MN;AI5ME;EACE,qCAAA;EACA,qDAAA;EACA,wBAAA;EF5EH,aAAA;EACA,mBE4EmB;EF3EnB,qBE2EwB;EF1ExB,mBE0E8B;EACzB,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;AJiNN;AI/MM;EACI,iBAAA;EACA,cAAA;EACA,eAAA;AJiNV;AI7MU;EFnFT,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBEgFoC;EACvB,kBAAA;AJmNd;AIjNU;EFvFT,oCAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBEoFoC;AJuNrC;;AI9ME;EACE,qCAAA;EACA,qDAAA;EACA,wBAAA;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;AJiNN;AIhNM;EFxGL,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBEqGgC;EAEvB,kBAAA;AJqNV;AInNM;EF7GL,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBE0GgC;EACvB,mBAAA;AJyNV;AIvNM;EFjHL,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBE8GgC;EACvB,kBAAA;AJ6NV;AI1NM;EFtHL,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBEmHgC;AJgOjC;AI7NE;EFjID,aAAA;EACA,mBEiImB;EFhInB,uBEgIwB;EF/HxB,mBE+HgC;AJkOjC;AIjOM;EF5HL,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBEyHgC;EACvB,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AJuOV;;AKhXA;EACI,UAAA;EACA,kBAAA;EHDH,aAAA;EACA,mBGCiB;EHAjB,8BAAA;EACA,mBGDqC;ALsXtC;AGpWE;EErBF;IAMQ,aAAA;IACA,sBAAA;ELuXN;AACF;AKtXI;EACI,eAAA;ALwXR;;AMnYA;EACI,sBAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;ANsYJ;;AMpYE;;EAEE,eAAA;EACA,iBAAA;ANuYJ;;AMrYE;;;;EAKU,sCAAA;ANwYZ;;AMtYE;EACE,eAAA;EACA,eAAA;ANyYJ;;AMvYE;EACE,kBAAA;AN0YJ;;AMxYE;EACE,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oHAAA;AN2YJ;;AMzYE;;EAEE,kBAAA;EACA,cAAA;AN4YJ;;AM1YE;EACE,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;AN6YJ;;AM3YE;EACE,cAAA;EACA,yBAAA;EACA,cAAA;EACA,6BAAA;EACA,oBAAA;AN8YJ;;AM5YE;EACE,cAAA;EACA,WAAA;AN+YJ;;AM7YE;EACE,eAAA;ANgZJ;;AM9YE;EACE,mBAAA;ANiZJ;;AM/YE;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;ANkZJ;;AMhZE;EACE,iBAAA;EACA,eAAA;ANmZJ;;AMjZE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ANoZJ;;AMlZE;EACE,cAAA;ANqZJ;;AMnZE;EACE,cAAA;ANsZJ;;AMpZE;EACE,cAAA;ANuZJ;;AMrZE;EACE,cAAA;ANwZJ;;AMtZE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;ANyZJ;;AMvZE;EACE,0BAAA;AN0ZJ;;AMxZE;EACE,YAAA;EACA,gBAAA;AN2ZJ;;AMzZE;EAEU,yBAAA;EAEA,+DAAA;EAEA,yBAAA;AN4ZZ;;AM1ZE;;EAGU,yBAAA;EAEA,+DAAA;EAEA,yBAAA;EACR,UAAA;EAEQ,4BAAA;AN6ZZ;;AM3ZE;EAEU,yBAAA;EAEA,+DAAA;EAEA,yBAAA;EAEA,wBAAA;EAEA,4BAAA;AN8ZZ;;AM5ZE;;EAGU,kCAAA;EAEA,6BAAA;AN+ZZ;;AM7ZE;EAEU,mCAAA;EAEA,6BAAA;ANgaZ;AMpZE;EACE;IACE,WAAA;IACA,UAAA;ENiaJ;EM/ZE;IACE,OAAA;IACA,UAAA;ENiaJ;AACF;AMrZE;EACE;IACE,YAAA;IACA,UAAA;ENiaJ;EM/ZE;IACE,QAAA;IACA,UAAA;ENiaJ;AACF;AMjZE;EACE;IACE,iBAAA;IACA,mBAAA;IACA,UAAA;ENiaJ;EM/ZE;IACE,aAAA;IACA,gBAAA;IACA,cAAA;IACA,iBAAA;IACA,UAAA;ENiaJ;AACF;AM/ZE;EACE,cAAA;ANiaJ;;AM/ZE;EACE,gBAAA;EACA,kBAAA;ANkaJ;;AMhaE;EACE,kBAAA;EACA,cAAA;ANmaJ;;AMjaE;EACE,kBAAA;EACA,cAAA;ANoaJ;;AMlaE;EACE,iBAAA;EACA,cAAA;ANqaJ;;AMnaE;EACE,WAAA;EACA,UAAA;ANsaJ;;AMpaE;EACE,WAAA;ANuaJ;;AMraA;EACI,kBAAA;EACA,mBAAA;ANwaJ;AMvaI;EACI,WAAA;EACA,YAAA;EJlQP,aAAA;EACA,sBIkQqB;EJjQrB,qBIiQ6B;EJhQ7B,mBIgQmC;EAC5B,sBAAA;AN4aR;AG5pBE;EG4OE;IAMQ,WAAA;EN8aV;AACF;AM7aQ;EACI,UAAA;EACA,cAAA;EJ1QX,aAAA;EACA,mBI0QyB;EJzQzB,8BIyQ8B;EJxQ9B,mBIwQ6C;ANkb9C;AGzqBE;EGoPM;IAKQ,WAAA;IJ7Qf,aAAA;IACA,sBI6Q6B;IJ5Q7B,qBI4QqC;IJ3QrC,uBI2Q2C;IAC5B,kBAAA;ENubd;AACF;AMtbY;EACI,UAAA;EACA,iBAAA;EJ5Qf,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBIyQsC;AN4bvC;AG5rBE;EG6PU;IAKQ,WAAA;IACA,iBAAA;IJhRnB,oCAAA;IACA,kBAAA;IACA,iBAAA;IACA,qBAAA;IACA,gBI6Q0C;IACvB,kBAAA;ENkclB;AACF;AMhcY;EACI,qCAAA;EACA,4CAAA;EACA,kBAAA;EACA,kBAAA;EJhSf,aAAA;EACA,mBIgS6B;EJ/R7B,uBI+RkC;EJ9RlC,uBI8R0C;EAC3B,sBAAA;ANqchB;AGntBE;EGwQU;IAQQ,UAAA;IACA,cAAA;ENuclB;AACF;AMtcgB;EACI,mBAAA;ANwcpB;AMvcoB;EJlSnB,oCAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,iBI+R8C;EACvB,oBAAA;AN6cxB;AM3coB;EJtSnB,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBImS8C;ANid/C;AM3cQ;EACI,UAAA;EACA,cAAA;EACA,YAAA;EACA,sBAAA;EACA,qCAAA;EACA,4CAAA;EACA,kBAAA;AN6cZ;AGpvBE;EGgSM;IASQ,WAAA;IACA,kBAAA;IACA,YAAA;IACA,sBAAA;EN+cd;AACF;AM9cY;EJ3TX,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBIwTsC;EACvB,kBAAA;ANodhB;AMldY;EJ/TX,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBI4TsC;EACvB,kBAAA;EACA,cAAA;ANwdhB;AMrdY;EACI,WAAA;EJ7Uf,aAAA;EACA,mBI6U6B;EJ5U7B,8BI4UkC;EJ3UlC,mBI2UiD;AN0dlD;AGpxBE;EGwTU;IJ5UX,aAAA;IACA,sBI+UiC;IJ9UjC,qBI8UyC;IJ7UzC,uBI6U+C;EN+d9C;AACF;AM9dgB;EJlVf,aAAA;EACA,mBIkViC;EJjVjC,qBIiVsC;EJhVtC,mBIgV4C;ANme7C;AGlyBE;EG8Tc;IJlVf,aAAA;IACA,sBIoVqC;IJnVrC,qBImV6C;IJlV7C,uBIkVmD;IAC5B,kBAAA;ENwetB;AACF;AMveoB;EACI,iBAAA;ANyexB;AG9yBE;EGoUkB;IAGQ,iBAAA;EN2e1B;AACF;AM1ewB;EACI,cAAA;EJvV3B,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBIoVkD;EACvB,kBAAA;ANgf5B;AG5zBE;EGyUsB;IAKQ,kBAAA;IJ3V/B,oCAAA;IACA,kBAAA;IACA,kBAAA;IACA,oBAAA;IACA,gBIwVsD;ENsfrD;AACF;AMpfwB;EJ/VvB,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBI4VkD;AN0fnD;AG70BE;EGkVsB;IJ/VvB,oCAAA;IACA,kBAAA;IACA,mBAAA;IACA,sBAAA;IACA,iBI8VsD;ENggBrD;AACF;AM9fwB;EJrWvB,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBIkWkD;ANogBnD;AG71BE;EGwVsB;IJrWvB,oCAAA;IACA,kBAAA;IACA,kBAAA;IACA,oBAAA;IACA,gBIoWsD;EN0gBrD;AACF;AMtgBgB;EACI,oBAAA;EJrXnB,aAAA;EACA,mBIqXiC;EJpXjC,qBIoXsC;EJnXtC,mBImX4C;AN2gB7C;AG72BE;EGgWc;IAIQ,sBAAA;IACA,WAAA;IJzXvB,aAAA;IACA,mBIyXqC;IJxXrC,8BIwX0C;IJvX1C,mBIuXyD;ENghBxD;AACF;AM/gBoB;EJ5XnB,aAAA;EACA,mBI4XqC;EJ3XrC,qBI2X0C;EJ1X1C,mBI0XgD;EACzB,eAAA;EACA,mBAAA;ANohBxB;AMnhBwB;EACI,mBAAA;EJ1X3B,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBIuXkD;ANyhBnD;AMlhBQ;EACI,UAAA;EACA,YAAA;EACA,cAAA;EJ5YX,aAAA;EACA,mBI4YyB;EJ3YzB,8BI2Y8B;EJ1Y9B,mBI0Y6C;ANuhB9C;AGh5BE;EGqXM;IJzYP,aAAA;IACA,sBI8Y6B;IJ7Y7B,qBI6YqC;IJ5YrC,uBI4Y2C;EN4hB1C;AACF;;AO56BA;EACI,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EAMA,qCAAA;EACA,4CAAA;EACA,kBAAA;AP06BJ;AGn6BE;EIpBF;IAOQ,WAAA;IACA,WAAA;IACA,kBAAA;EPo7BN;AACF;AOh7BI;EACI,sBAAA;EACJ,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;APk7BJ;AOh7BI;ELjBH,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBKc8B;EACvB,oBAAA;EACA,sBAAA;EACD,kBAAA;EACA,gBAAA;APs7BP;AG/7BE;EIIE;ILjBH,oCAAA;IACA,kBAAA;IACA,oBAAA;IACA,oBAAA;IACA,gBKoBkC;EP47BjC;AACF;AO17BI;EL3BH,oCAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBKwB8B;EACvB,kBAAA;APg8BR;AGh9BE;EIcE;IL3BH,oCAAA;IACA,kBAAA;IACA,mBAAA;IACA,qBAAA;IACA,gBK2BkC;EPs8BjC;AACF;AOr8BQ;ELjCP,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBK8BkC;AP28BnC;AGh+BE;EIoBM;ILjCP,oCAAA;IACA,kBAAA;IACA,oBAAA;IACA,oBAAA;IACA,gBKgCsC;EPi9BrC;AACF;;AO58BA;EACI,kBAAA;EACA,kBAAA;AP+8BJ;;AO38BA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,sBAAA;EACJ,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,YAAA;EAGA,cAAA;AP48BA;;AOx8BI;EADJ;IAEE,WAAA;EP48BA;AACF;AO38BC;EAJD;IAKQ,WAAA;EP88BN;AACF;AO58BI;EARJ;IASQ,WAAA;EP+8BN;AACF;;AO58BA;EAmDI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AP65BJ;AOl9BI;EADJ;IAEQ,kBAAA;IACA,SAAA;IACA,UAAA;IACA,gCAAA;IACA,yBAAA;EPq9BN;AACF;AOp9BC;EARD;IASQ,kBAAA;IACJ,SAAA;IACA,UAAA;IACA,gCAAA;IACA,yBAAA;IACA,YAAA;EPu9BF;AACF;AOr9BI;EAjBJ;IAkBQ,kBAAA;IACJ,QAAA;IACA,UAAA;IACA,gCAAA;IACA,yBAAA;IACA,YAAA;EPw9BF;AACF;AOt9BI;EA1BJ;IA2BQ,kBAAA;IACJ,QAAA;IACA,UAAA;IACA,gCAAA;IACA,yBAAA;IACA,YAAA;EPy9BF;AACF;AOx9BI;EAlCJ;IAmCQ,kBAAA;IACJ,QAAA;IACA,UAAA;IACA,gCAAA;IACA,yBAAA;IACA,YAAA;EP29BF;AACF;AOz9BI;EA3CJ;IA4CQ,kBAAA;IACJ,QAAA;IACA,UAAA;IACA,gCAAA;IACA,yBAAA;IACA,YAAA;EP49BF;AACF;AOh9BI;EA9DJ;IAmEQ,kBAAA;IACI,QAAA;IACA,UAAA;IACA,gCAAA;IACA,yBAAA;EP+8BV;AACF;;AOz8BI;EADF;IAEM,WAAA;EP68BN;AACF;AO58BC;EAJC;IAKM,WAAA;EP+8BN;AACF;AO78BI;EARF;IASM,WAAA;EPg9BN;AACF;AO/8BI;EAXF;IAgBM,WAAA;EP88BN;AACF;;AOr8BA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACJ,YAAA;EAGA,cAAA;APs8BA;;AOj8BA;EL/MC,aAAA;EACA,mBK+MiB;EL9MjB,8BK8MsB;EL7MtB,mBK6MqC;EAClC,gBAAA;EACA,oBAAA;EACA,sBAAA;APu8BJ;AGtoCE;EI2LF;IAMQ,sBAAA;IACA,uBAAA;IACA,oBAAA;EPy8BN;AACF;AOx8BI;EACI,QAAA;ELnNP,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBKgN8B;EACvB,cAAA;AP88BR;AGtpCE;EIqME;IAKQ,QAAA;EPg9BV;AACF;AO98BI;EACI,QAAA;ELlOP,aAAA;EACA,mBKkOqB;ELjOrB,qBKiO0B;ELhO1B,mBKgOgC;EACzB,gBAAA;EACA,SAAA;EACA,UAAA;APm9BR;AGrqCE;EI6ME;IAOQ,QAAA;EPq9BV;AACF;AOp9BQ;EACI,mBAAA;ELpOX,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBKiOkC;EACvB,eAAA;AP09BZ;;AQxsCA;EACC,4CAAA;EACA,kBAAA;EACA,kBAAA;AR2sCD;AQ1sCC;EACC,kBAAA;AR4sCF;AG5rCE;EKjBD;IAGE,cAAA;ER8sCD;AACF;AQ5sCC;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACM,yBAAA;AR8sCR;AQ5sCE;EACC,eAAA;EACA,YAAA;AR8sCH;AQ5sCG;EACC,YAAA;AR8sCJ;AQ5sCI;EACC,gBAAA;EACA,oBAAA;ENjBJ,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBMc0C;ARktC3C;AQ9sCE;EACC,gBAAA;EACA,gBAAA;EACS,qCAAA;EACA,4CAAA;EACA,mBAAA;EACT,gBAAA;ARgtCH;AQ9sCG;EACC,YAAA;EACY,kDAAA;EACZ,gBAAA;ARgtCJ;AQ9sCG;EACC,mBAAA;ARgtCJ;AQ9sCY;ENtCX,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBMmCsC;ARotCvC;AQjtCE;EACC,gBAAA;EACA,qBAAA;ARmtCH;AQjtCE;EACC,qBAAA;ARmtCH;AGjvCE;EKiCC;IACC,iBAAA;IACA,mBAAA;ERmtCF;EQjtCC;IACC,iBAAA;IACA,mBAAA;ERmtCF;AACF;AQhtCC;EACC,gBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;EACA,cAAA;EACA,sBAAA;ARktCF;AQhtCC;EACC,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;ARktCF;AQjtCE;EACC,kBAAA;ARmtCH;AQltCG;EACC,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;ARotCJ;AQntCI;EACC,SAAA;EACA,SAAA;EACA,kBAAA;ARqtCL;AQntCI;EACC,sBAAA;EACA,WAAA;ARqtCL;AQltCG;EACC,eAAA;ARotCJ;;AQ9sCA;EN7GC,aAAA;EACA,mBM6Gc;EN5Gd,qBM4GmB;EN3GnB,mBM2GyB;EACzB,0BAAA;EACA,cAAA;ARotCD;AQntCE;EACA,mBAAA;ARqtCF;;AQltCA;EN9GC,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBM2GuB;EACvB,0BAAA;EACA,cAAA;ARytCD;;AQvtCA;ENnHC,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBMgHuB;EACvB,0BAAA;EACA,cAAA;AR8tCD;;AS51CA;EACI,mBAAA;AT+1CJ;AS91CI;EACI,eAAA;ATg2CR;AS/1CQ;EPHP,aAAA;EACA,mBOGyB;EPFzB,qBOE8B;EPD9B,mBOCoC;ATo2CrC;ASn2CY;EACI,mBAAA;EACA,eAAA;ATq2ChB;AGx1CE;EMfU;IAIQ,iBAAA;ETu2ClB;AACF;ASp2CgB;EPNf,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBOG0C;AT02C3C;AGp2CE;EMPc;IPNf,oCAAA;IACA,kBAAA;IACA,mBAAA;IACA,oBAAA;IACA,gBOK8C;ETg3C7C;AACF;AS92CgB;EPZf,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBOS0C;ATo3C3C;AGp3CE;EMDc;IPZf,oCAAA;IACA,kBAAA;IACA,kBAAA;IACA,sBAAA;IACA,gBOW8C;ET03C7C;AACF;ASt3CQ;EACI,eAAA;ATw3CZ;;AUp5CI;EACI,eAAA;AVu5CR;AUr5CI;EACI,WAAA;ERGP,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBQN8B;EACvB,aAAA;EACA,mBAAA;EAEA,oBAAA;ERTP,aAAA;EACA,mBQSqB;ERRrB,qBQQ0B;ERP1B,uBQOgC;AV65CjC;AU35CQ;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AV65CV;AU35CQ;EACE,aAAA;AV65CV;AU15CI;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;ERvBP,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBQoB8B;EAGvB,eAAA;EACA,6BAAA;EACA,cAAA;AV85CR;AUz5CI;EACI,WAAA;EACA,qBAAA;AV25CR;AU15CQ;EACI,yBAAA;EACA,YAAA;ERvCX,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBQoCkC;EACvB,cAAA;EACA,gBAAA;EACA,6BAAA;EACA,gCAAA;AVg6CZ;;AWh9CA;EACE,WAAA;ETJD,aAAA;EACA,sBSIe;ETHf,qBSGuB;ETFvB,iBSE6B;EAC5B,mBAAA;AXs9CF;AWr9CE;EACE,eAAA;AXu9CJ;AWr9CE;EACE,eAAA;AXu9CJ;AWp9CE;ETdD,aAAA;EACA,mBSciB;ETbjB,8BSasB;ETZtB,mBSYqC;EAClC,WAAA;AXy9CJ;AWx9CI;EACE,wBAAA;EACA,WAAA;AX09CN;AWz9CM;EACE,WAAA;ETdP,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBSW8B;EACvB,aAAA;EACA,mBAAA;EAEA,oBAAA;ET1BP,aAAA;EACA,mBS0BqB;ETzBrB,qBSyB0B;ETxB1B,uBSwBgC;AXi+CjC;AW/9CQ;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AXi+CV;AW/9CQ;EACE,aAAA;AXi+CV;AW99CM;ET/BL,oCAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBS6B8B;EACvB,qBAAA;AXm+CR;AWh+CI;EACE,sBAAA;AXk+CN;AW99CE;EACE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;ETtDH,aAAA;EACA,mBSsDiB;ETrDjB,8BSqDsB;ETpDtB,mBSoDqC;EAClC,mBAAA;AXm+CJ;AGvgDE;EQ6BA;IASI,YAAA;EXq+CJ;AACF;AWn+CI;EACE,WAAA;ET9DL,aAAA;EACA,mBS8DmB;ET7DnB,qBS6DwB;ET5DxB,mBS4D8B;EACzB,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;ET7DL,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBS0D4B;EACvB,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;AX4+CN;AGliDE;EQyCE;IAeI,WAAA;ITrEP,oCAAA;IACA,kBAAA;IACA,oBAAA;IACA,sBAAA;IACA,iBSkE8B;EXk/C7B;AACF;AWj/CM;EACE,kBAAA;ETzEP,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBSsE8B;AXu/C/B;AWp/CI;EACE,UAAA;EACA,YAAA;EACA,sBAAA;ETvFL,aAAA;EACA,mBSuFmB;ETtFnB,uBSsFwB;ETrFxB,mBSqFgC;EAC3B,gCAAA;AXy/CN;AG9jDE;EQgEE;IAOI,UAAA;EX2/CN;AACF;AWv/CE;EACE,yBAAA;AXy/CJ;AWx/CM;EACE,UAAA;EACA,cAAA;AX0/CR;AWx/CM;EACE,UAAA;AX0/CR;AG7kDE;EQuFM;IACE,UAAA;EXy/CR;EWv/CM;IACE,UAAA;EXy/CR;AACF;AWj/CE;ETxHD,aAAA;EACA,mBSwHiB;ETvHjB,8BSuHsB;ETtHtB,mBSsHqC;EAClC,cAAA;EACA,sBAAA;EACA,WAAA;AXs/CJ;AWr/CI;ETtHH,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBSmH4B;AX2/C7B;AGrmDE;EQyGE;ITtHH,oCAAA;IACA,kBAAA;IACA,mBAAA;IACA,oBAAA;IACA,iBSsH8B;EXggD7B;AACF;AW9/CI;ETpIH,aAAA;EACA,mBSoImB;ETnInB,qBSmIwB;ETlIxB,mBSkI8B;AXmgD/B;AWlgDM;ETtIL,aAAA;EACA,mBSsIqB;ETrIrB,qBSqI0B;ETpI1B,mBSoIgC;AXugDjC;AWtgDQ;ETjIP,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBS8HgC;AX4gDjC;AWzgDQ;ETrIP,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBSkIgC;EACvB,kBAAA;AX+gDV;AW7gDQ;EACE,mBAAA;ET1IT,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBSuIgC;EACvB,cAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;AXmhDV;AW7gDE;EACE,UAAA;ET9JH,aAAA;EACA,mBS8JiB;ET7JjB,8BS6JsB;ET5JtB,mBS4JqC;AXkhDtC;AWjhDI;EACE,eAAA;AXmhDN;AW/gDE;EACE,UAAA;ETtKH,aAAA;EACA,mBSsKiB;ETrKjB,6BSqKsB;ETpKtB,mBSoKoC;AXohDrC;AGvqDE;EQiJA;IAII,UAAA;EXshDJ;AACF;AG5qDE;EQuJE;IAEI,UAAA;IACA,WAAA;EXuhDN;AACF;AWrhDI;ET1KH,oCAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBSuK4B;AX2hD7B;AGzrDE;EQ6JE;IT1KH,oCAAA;IACA,kBAAA;IACA,kBAAA;IACA,oBAAA;IACA,iBSyK8B;EXiiD7B;AACF;;AW5hDA;EACE,WAAA;ET3LD,aAAA;EACA,mBS2Le;ET1Lf,8BS0LoB;ETzLpB,mBSyLmC;AXkiDpC;AWjiDE;EACE,cAAA;ETvLH,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBSoL0B;AXuiD3B;AWtiDI;EACE,kBAAA;AXwiDN;;AY1uDA;EACI,WAAA;EACA,YAAA;EVDH,aAAA;EACA,mBUCiB;EVAjB,qBAAA;EACA,iBUD4B;AZgvD7B;AG9tDE;ESrBF;IAKQ,sBAAA;EZkvDN;AACF;AYjvDI;EVCH,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBUJ8B;EACvB,kBAAA;AZuvDR;AYpvDI;EACI,UAAA;EACA,iDAAA;AZsvDR;AG/uDE;ESTE;IAIQ,WAAA;IACA,WAAA;IACA,sBAAA;IACA,kBAAA;EZwvDV;AACF;AYvvDQ;EACI,kBAAA;EACA,sBAAA;AZyvDZ;AYnvDI;EACI,uBAAA;EACA,aAAA;EAEA,mBAAA;EAEA,8BAAA;AZqvDR;AYlvDI;EACI,kCAAA;EACJ,wBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AZovDJ;AYlvDI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;AZovDR;AYhvDI;EACI,UAAA;EACA,0BAAA;EACA,sBAAA;AZkvDR;AGxxDE;ESmCE;IAKQ,WAAA;IACA,WAAA;IACA,sBAAA;EZovDV;AACF;AYnvDQ;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EVnEX,aAAA;EACA,mBUmEyB;EVlEzB,qBUkE8B;EVjE9B,iBUiEoC;AZwvDrC;AYvvDY;EACI,iBAAA;AZyvDhB;AYvvDY;EACI,WAAA;EACA,gBAAA;EV1Ef,aAAA;EACA,sBU0E6B;EVzE7B,8BUyEqC;EVxErC,iBUwEoD;AZ4vDrD;AY3vDgB;EV5Ef,aAAA;EACA,mBU6EiC;EV5EjC,8BU4EsC;EV3EtC,mBU2EqD;AZ+vDtD;AY9vDoB;EACI,cAAA;AZgwDxB;AY9vDoB;EACI,+BAAA;AZgwDxB;AY3vDQ;EVxFP,aAAA;EACA,mBUwFyB;EVvFzB,8BUuF8B;EVtF9B,mBUsF6C;EAClC,kBAAA;AZgwDZ;AY/vDY;EACI,cAAA;AZiwDhB;AY/vDY;EACI,cAAA;AZiwDhB;AY9vDQ;EVlGP,aAAA;EACA,mBUkGyB;EVjGzB,qBUiG8B;EVhG9B,mBUgGoC;EACzB,aAAA;AZmwDZ;AYlwDY;EACI,iBAAA;AZowDhB;AYlwDY;EACI,+BAAA;AZowDhB;;Aa/2DA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;Abk3DF;;Aah3DA;;EAEE,eAAA;EACA,iBAAA;Abm3DF;;Aaj3DA;;;;EAKU,sCAAA;Abo3DV;;Aal3DA;EACE,eAAA;EACA,eAAA;Abq3DF;;Aan3DA;EACE,kBAAA;Abs3DF;;Aap3DA;EACE,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oHAAA;Abu3DF;;Aar3DA;;EAEE,kBAAA;EACA,cAAA;Abw3DF;;Aat3DA;EACE,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;Aby3DF;;Aav3DA;EACE,cAAA;EACA,yBAAA;EACA,cAAA;EACA,6BAAA;EACA,oBAAA;Ab03DF;;Aax3DA;EACE,cAAA;EACA,WAAA;Ab23DF;;Aaz3DA;EACE,eAAA;Ab43DF;;Aa13DA;EACE,mBAAA;Ab63DF;;Aa33DA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;Ab83DF;;Aa53DA;EACE,iBAAA;EACA,eAAA;Ab+3DF;;Aa73DA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;Abg4DF;;Aa93DA;EACE,cAAA;Abi4DF;;Aa/3DA;EACE,cAAA;Abk4DF;;Aah4DA;EACE,cAAA;Abm4DF;;Aaj4DA;EACE,cAAA;Abo4DF;;Aal4DA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;Abq4DF;;Aan4DA;EACE,0BAAA;Abs4DF;;Aap4DA;EACE,YAAA;EACA,gBAAA;Abu4DF;;Aar4DA;EAEU,yBAAA;EAEA,+DAAA;EAEA,yBAAA;Abw4DV;;Aat4DA;;EAGU,yBAAA;EAEA,+DAAA;EAEA,yBAAA;EACR,UAAA;EAEQ,4BAAA;Aby4DV;;Aav4DA;EAEU,yBAAA;EAEA,+DAAA;EAEA,yBAAA;EAEA,wBAAA;EAEA,4BAAA;Ab04DV;;Aax4DA;;EAGU,kCAAA;EAEA,6BAAA;Ab24DV;;Aaz4DA;EAEU,mCAAA;EAEA,6BAAA;Ab44DV;Aah4DA;EACE;IACE,WAAA;IACA,UAAA;Eb64DF;Ea34DA;IACE,OAAA;IACA,UAAA;Eb64DF;AACF;Aaj4DA;EACE;IACE,YAAA;IACA,UAAA;Eb64DF;Ea34DA;IACE,QAAA;IACA,UAAA;Eb64DF;AACF;Aa73DA;EACE;IACE,iBAAA;IACA,mBAAA;IACA,UAAA;Eb64DF;Ea34DA;IACE,aAAA;IACA,gBAAA;IACA,cAAA;IACA,iBAAA;IACA,UAAA;Eb64DF;AACF;Aa34DA;EACE,cAAA;Ab64DF;;Aa34DA;EACE,gBAAA;EACA,kBAAA;Ab84DF;;Aa54DA;EACE,kBAAA;EACA,cAAA;Ab+4DF;;Aa74DA;EACE,kBAAA;EACA,cAAA;Abg5DF;;Aa94DA;EACE,iBAAA;EACA,cAAA;Abi5DF;;Aa/4DA;EACE,WAAA;EACA,UAAA;Abk5DF;;Aah5DA;EACE,WAAA;Abm5DF;;Ac/oEA;EACC,aAAA;EACA,mBAAA;AdkpED;AchpEC;EACC,0CAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AdkpEF;AchpEE;EACC,SAAA;EACA,+BAAA;AdkpEH;;Ac7oEA;EACC,aAAA;EACA,mBAAA;AdgpED;Ac9oEC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,8BAAA;AdgpEF;;Ac5oEA;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;Ad+oED;;Ac5oEA;EACC,gBAAA;Ad+oED;;Ac5oEA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;Ad+oED;Ac7oEC;EALD;IAME,mBAAA;EdgpEA;AACF;;Ac5oEA;EACC,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACE,YAAA;EACF,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qCAAA;EACA,sBAAA;EACA,uDAAA;EACA,wBAAA;EACA,aAAA;Ad+oED;Ac7oEC;EACC,mBAAA;EACA,YAAA;EACA,mBAAA;Ad+oEF;Ac5oEC;EAxBD;IAyBE,UAAA;Ed+oEA;AACF;Ac7oEC;EACC,iBAAA;EACA,cAAA;Ad+oEF;Ac5oEC;EACC,cAAA;EACA,eAAA;EACA,gBAAA;Ad8oEF;Ac3oEC;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,+BAAA;Ad6oEF;;AczoEA;EACC,aAAA;EACA,gBAAA;EACA,mBAAA;Ad4oED;Ac1oEC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;Ad4oEF;AczoEC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;Ad2oEF;;AcvoEA;EACC,WAAA;EACG,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,oBAAA;EACA,kBAAA;Ad0oEJ;AczoEI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,cAAA;Ad2oER;AcxoEI;EACI,eAAA;EACA,cAAA;Ad0oER;AcvoEI;EACI,SAAA;EACA,cAAA;AdyoER;ActoEI;EACI,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AdwoER;AcpoEQ;EACI,cAAA;AdsoEZ;;AcloEA;EACC,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,sEAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AdqoED;AcnoEC;EACC,oBAAA;EACA,mBAAA;AdqoEF;AcloEC;EACC,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AdooEF;AcjoEC;EACC,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AdmoEF;AcjoEE;EACC,WAAA;AdmoEH;Ac/nEC;EACC,iBAAA;AdioEF;Ac5nEC;EACC,iBAAA;EACA,WAAA;EACM,YAAA;Ad8nER;Ac3nEC;EAxDD;IAyDE,aAAA;IACA,sEAAA;IAEA,eAAA;Ed6nEA;Ec1nEC;IACC,WAAA;Ed4nEF;AACF;AcxnEC;EArED;IAsEE,aAAA;IACA,sEAAA;IAEA,eAAA;Ed0nEA;EcvnEC;IACC,WAAA;EdynEF;AACF;;AcpnEA;EACC,gBAAA;EACA,0CAAA;EACA,sBAAA;EACA,uDAAA;EACA,wBAAA;EACA,aAAA;AdunED;;AcpnEA;EACC,aAAA;AdunED;AcrnEC;EACC,mBAAA;AdunEF;;AclnEA;EACE,aAAA;EACD,sBAAA;EACA,aAAA;AdqnED;AcnnEC;EACC,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AdqnEF;AcnnEE;EACC,gBAAA;AdqnEH;AcjnEC;EAhBD;IAiBE,mBAAA;IACA,8BAAA;EdonEA;AACF;;Ac9mEA;EACC,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EAGA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;EAWA,sBAAA;AdqmED;Ac/mEC;EAfD;IAgBE,eAAA;EdknEA;AACF;AcjnEC;EAlBD;IAmBE,eAAA;EdonEA;AACF;;AAx6EA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;EACA,cAAA;AA26EF;AAz6EE;EACE,SAAA;AA26EJ;;AAv6EA;EACE,aAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,WAAA;AA06EF;;AAv6EA;EACE,cAAA;AA06EF;;AAt6EA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,oCAAA;EACA,iCAAA;AAy6EF;;AAt6EA;EACE,UAAA;AAy6EF;;AAt6EA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AAy6EF;;AAt6EA;EACE,kBAAA;EACA,mBAAA;EACA,mDAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EACA,uBAAA;EACA,oBAAA;EACA,iCAAA;AAy6EF;;AAt6EA;EACE,SAAA;AAy6EF;;AAt6EA;EACE,eAAA;AAy6EF;;AAt6EA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAy6EF;;AAt6EA;EACE;IACE,mBAAA;EAy6EF;EAr6EA;IACE,cAAA;IACA,uBAAA;IACA,mBAAA;EAu6EF;AACF;AAp6EA;EACE,kBAAA;AAs6EF","sourcesContent":[".App {\n  width: 100vw;\n  min-height: 100vh;\n  position: relative;\n  // padding: 3% 5% 0 5%;\n  box-sizing: border-box;\n  // background: #1C1D21;\n}\n\n","@import \"./mixins.scss\";\n@import \"./screens.scss\";\n@import \"./App.scss\";\n@import \"./button.scss\";\n@import \"./modal.scss\";\n@import \"./navbar.scss\";\n@import \"./home.scss\";\n@import \"./partials.scss\";\n@import \"./table.scss\";\n@import \"./transaction.scss\";\n@import \"./filter.scss\";\n@import \"./input.scss\";\n@import \"./staking.scss\";\n@import \"./notifier.scss\";\n@import \"./connectionModal.scss\";\n\n\nbody {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Fira Sans', sans-serif;\n  background: #070E17;\n  color: #ffffff;\n\n  p{\n    margin: 0;\n  }\n}\n\n.modal-styles {\n  display: none;\n  width: 100%;\n  max-width: 600;\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: fixed;\n  z-index: 10;\n}\n\n.modal-styles.open {\n  display: block;\n\n}\n\n.modal-body {\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.7);\n  transition: all 500ms ease-in-out;\n}\n\n.modal-body.show {\n  opacity: 1;\n}\n\n.modal-body > div {\n  display: flex;\n  justify-content: center;\n  padding-top: 120px;\n}\n\n.modal-content {\n  position: relative;\n  border-radius: 20px;\n  box-shadow: 0 10px 20px #0000002f;\n  padding: 30px;\n  width: 90%;\n  background-color: #070E17;\n  /* min-height: 100vh; */\n  /* bottom: -100vh; */\n  transition: all 500ms ease-in-out;\n}\n\n.modal-content.open {\n  bottom: 0;\n}\n\n.modal-content .title {\n  font-size: 18px;\n}\n\n.close-modal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n@media (min-width: 768px) {\n  .modal-body > div {\n    align-items: center;\n    \n  }\n\n  .modal-content {\n    max-width: 25%;\n    /* min-height: 300px; */\n    /* bottom: -10vh; */\n  }\n}\n\n.t-center{\n  text-align: center;\n}","\n\n.button {\n  padding: 2px;\n  cursor: pointer;\n  background: linear-gradient(92.28deg, #2042B8 0.63%, #FF6600 109.77%);\n  border-radius: 30px;\n  @include flex(column, center, center);\n  border: none;\n  outline: none;\n  @include screen(\"inbetween\") {\n  }\n  p{\n    padding: 1.3vh 3vw;\n    color: #ffff;\n    font-style: normal;\n    @include fonts(18, 23, bold);\n    text-align: center;\n    margin: 0;\n    @include screen(\"inbetween\") {\n      @include fonts(14, 20, bold);\n    }\n  }\n  @include screen(\"inbetween\") {\n    min-width: 0;\n  }\n  &.stake-btn{\n    width: 80%;\n    margin: 0 auto;\n    @include fonts(14, 17, 500);\n  }\n  \n  //// secondary /////\n  &.secondary{\n    box-shadow: none;\n    @include screen(\"inbetween\") {\n    }\n    .btn-inside{\n      width: 100%;\n      // background-color: white;\n      border-radius: 30px;\n      @include flex(column, center, center);\n      p{\n        padding: 1.5vh 3vw;\n        margin: 0;\n        @include fonts(18, 23, bold);\n        background: linear-gradient(44.25deg, #E8433D 25.64%, #FF6600 53.43%);\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n        @include screen(\"inbetween\") {\n          font-size: 0.8rem;\n          padding: 1vh 5vh;\n        }\n      }\n    }\n  }\n\n  ////// tertiary buttons //////// \n  &.tertiary{\n    border: 2px solid #FFFFFF;\n    box-sizing: border-box;\n    border-radius: 28px;\n    background: transparent;\n    background-color: transparent;\n    padding: 0;\n    .btn-inside{\n      // background-color: #ffff;\n      padding: 0;\n      border-radius: 28px;\n      p{\n        @include fonts(14, 18, bold);\n        // color: #1F1F20;\n        // background: #ffff;\n        padding: 1.3vh 2vw;\n        /// white-space: nowrap;\n        border-radius: 28px;\n        margin: 0;\n      }\n    }\n    @include screen(\"inbetween\") {\n      .btn-inside{\n        p{\n          padding: 1vh 2vw;\n          @include fonts(11, 13, bold);\n        }\n      }\n    }\n    &.card-btn{\n      justify-self: center;\n      margin: 0 auto;\n      @include screen(\"inbetween\") {\n        width: 100%;\n      }\n    }\n  }\n}\n\n//// capsule btn ////////\n.capsule-btn{\n  // min-width: 15vw;\n  min-width: 18%;\n  position: relative;\n  @include screen(\"inbetween\") {\n    min-width: 50%;\n  }\n\n  .left-capsule{\n    // background: linear-gradient(44.25deg, #E8433D 25.64%, #FF6600 53.43%);\n    background: rgba(255, 255, 255, 0.14);\n    color: #FFFFFF;\n    // width: 9vw;\n    width: 60%;\n    padding: 1.3vh 1vw 1.3vh 1vw;\n    box-sizing: border-box;\n    border-radius: 60px;\n    @include fonts(13, 16, bold);\n    cursor: pointer;\n    @include screen(\"inbetween\") {\n      @include fonts(10, 16, bold);\n      padding-left: 5%;\n    }\n  }\n  .right-capsule{\n    background: #5A5F6E;\n    color: #FFFFFF;\n    // width: 9vw;\n    width: 55%;\n    padding: 1.3vh 1vw 1.3vh 1vw;\n    box-sizing: border-box;\n    border-radius: 60px;\n    z-index: 50;\n    position: absolute;\n    right: 0;\n    top: 0;\n    left: 45%;\n    @include fonts(13, 16, bold);\n    cursor: pointer;\n    text-align: center;\n    @include screen(\"inbetween\") {\n      @include fonts(10, 16, bold);\n      // padding-left: 5%;\n    }\n  }\n}\n\n\n.connect-wallet {\n  @include flex(row, space-between, center);\n  .wallet-img {\n    margin-right: 1vw;\n  }\n}\n\n","\n@mixin flex($direction, $justify, $align) {\n\tdisplay: flex;\n\tflex-direction: $direction;\n\tjustify-content: $justify;\n\talign-items: $align;\n}\n\n@mixin fonts($size, $height, $weight ) {\n\tfont-family: 'Fira Sans', sans-serif;\n\tfont-style: normal;\n\tfont-size: ($size / 16) + rem;\n\tline-height: ($height / 16) + rem;\n\tfont-weight: $weight;\n}\n\n","@mixin screen($size) {\n\t@if ($size == \"xx-large\") {\n\t\t@media screen and (max-width: 1440px) {\n\t\t\t@content;\n\t\t}\n\t}\n\t@if ($size == \"x-large\") {\n\t\t@media screen and (max-width: 1280px) {\n\t\t\t@content;\n\t\t}\n\t}\n\t@if ($size == \"large\") {\n\t\t@media screen and (max-width: 1024px) {\n\t\t\t@content;\n\t\t}\n\t}\n\t@if ($size == \"medium\") {\n\t\t@media screen and (max-width: 991px) {\n\t\t\t@content;\n\t\t}\n\t}\n\t@if ($size == \"inbetween\") {\n\t\t@media screen and (max-width: 767.99px) {\n\t\t\t@content;\n\t\t}\n\t} @else if($size == \"small\") {\n\t\t@media screen and (max-width: 576px) {\n\t\t\t@content;\n\t\t}\n\t} @else if($size == \"x-small\") {\n\t\t@media screen and (max-width: 414px) {\n\t\t\t@content;\n\t\t}\n\t}\n}\n",".modal-cont {\n    display: block;\n    min-width: 100vw;\n    min-height: 100vh;\n    @include flex(column, center, center);\n    z-index: 1000;\n    position: fixed;\n    top: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.62);\n    // background-color: yellow;\n    overflow-y: scroll;\n    box-sizing: border-box;\n    @include screen(\"inbetween\") {\n      width: 100%;\n    }\n  \n    &.hidden {\n      display: none; \n    }\n  \n    .content-cont {\n      min-width: 30%;\n      //   min-width: 10%;\n      min-height: 45vh;\n      max-height: 95vh;\n      z-index: 3000;\n      background-color: #1C1D21;\n      padding: 1rem 1.5rem;\n      @include flex(column, nill, nill);\n      // color: black;\n      border-radius: 4px;\n      overflow-y: auto;\n      box-sizing: border-box;\n      // border: 1px solid red;\n      @include screen(\"inbetween\") {\n        min-width: 95%;\n        max-width: 100%;\n        width: 100%;\n        max-height: 75vh;\n      }\n      .header {\n        @include flex(row, space-between, center);\n        margin-bottom: 5vh;\n        #modal-title{\n          justify-self: flex-start;\n          @include fonts(24, 31, bold);\n        }\n        #close-modal {\n          // width: 2.5rem;\n          // height: 2.5rem;\n          cursor: pointer;\n          justify-self: flex-end;\n        //   border: 1px solid #d3d1d1;\n          padding: 0.5rem;\n          border-radius: 6px;\n        }\n      }\n      &.stake-modal{\n        min-width: 70%;\n        border-radius: 22px;\n        padding-right: 0;\n      }\n    }\n }\n\n\n\n ////// ConnectWalletForm //////\n.wallet-form-1{\n    // border: 1px solid red;\n  #title-1{\n      @include fonts(24, 31, bold);\n      margin-bottom: 7vh;\n  }\n  .wallet-box{\n    background: rgba(255, 255, 255, 0.05);\n    box-shadow: 0px 17.8125px 18.525px rgba(0, 0, 0, 0.1);\n    border-radius: 5.44429px;\n      @include flex(row, nill, center);\n      margin-bottom: 3vh;\n      padding: 1.5vw;\n      box-sizing: border-box;\n      cursor: pointer;\n    //   border: 1px solid cyan;\n      #wallet-img{\n          margin-right: 2vw;\n          min-width: 5vw;\n          min-height: 4vh;\n        //   border: 1px solid red;\n      }\n      .details{\n          #wallet{\n              @include fonts(18, 23, bold);\n              margin-bottom: 1vh;\n          }\n          #info{\n              @include fonts(13, 17, 600);\n          }\n      }\n  }\n}\n\n\n////// WalletConnectedForm ////////\n.wallet-form-2{\n  .wallet-details{\n    background: rgba(255, 255, 255, 0.05);\n    box-shadow: 0px 17.8125px 18.525px rgba(0, 0, 0, 0.1);\n    border-radius: 5.44429px;\n      padding: 2vw;\n      margin-bottom: 5vh;\n      box-sizing: border-box;\n      #chain{\n          @include fonts(14, 18, 600);\n          // color: #6D6D6D;\n          margin-bottom: 1vh;\n      }\n      #value{\n          @include fonts(18, 23, bold);\n          margin-bottom: 10vh;\n      }\n      #wallet-address{\n          @include fonts(14, 18, 600);\n          margin-bottom: 1vh;\n          // color: #6D6D6D;\n      }\n      #wallet{\n          @include fonts(18, 23, bold);\n      }\n  }\n  .btn-cont{\n      @include flex(row, center, center);\n      #disconnect-btn{\n          @include fonts(18, 23, bold);\n          color: #FF6600;\n          margin-bottom: 5vh;\n          padding: 0 0.2vw;\n          cursor: pointer;\n      }\n  }\n  \n}\n  ","\nnav {\n    width: 80%;\n    position: relative;\n    @include flex(row, space-between, center);\n    // border: 1px solid blue;\n    @include screen(\"inbetween\") {\n        padding: 0 5%;\n        box-sizing: border-box;\n    }\n    .logo{\n        cursor: pointer;\n    }\n}\n",".ant-notification {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    color: rgba(0, 0, 0, 0.85);\n    font-size: 14px;\n    font-variant: tabular-nums;\n    line-height: 1.5715;\n    list-style: none;\n    font-feature-settings: 'tnum';\n    position: fixed;\n    z-index: 1010;\n    margin-right: 24px;\n  }\n  .ant-notification-topLeft,\n  .ant-notification-bottomLeft {\n    margin-right: 0;\n    margin-left: 24px;\n  }\n  .ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n  .ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n  .ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active,\n  .ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active {\n    -webkit-animation-name: NotificationLeftFadeIn;\n            animation-name: NotificationLeftFadeIn;\n  }\n  .ant-notification-close-icon {\n    font-size: 14px;\n    cursor: pointer;\n  }\n  .ant-notification-hook-holder {\n    position: relative;\n  }\n  .ant-notification-notice {\n    position: relative;\n    width: 384px;\n    max-width: calc(100vw - 24px * 2);\n    margin-bottom: 16px;\n    margin-left: auto;\n    padding: 16px 24px;\n    overflow: hidden;\n    line-height: 1.5715;\n    word-wrap: break-word;\n    background: #fff;\n    border-radius: 2px;\n    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  }\n  .ant-notification-topLeft .ant-notification-notice,\n  .ant-notification-bottomLeft .ant-notification-notice {\n    margin-right: auto;\n    margin-left: 0;\n  }\n  .ant-notification-notice-message {\n    margin-bottom: 8px;\n    color: rgba(0, 0, 0, 0.85);\n    font-size: 16px;\n    line-height: 24px;\n  }\n  .ant-notification-notice-message-single-line-auto-margin {\n    display: block;\n    width: calc(384px - 24px * 2 - 24px - 48px - 100%);\n    max-width: 4px;\n    background-color: transparent;\n    pointer-events: none;\n  }\n  .ant-notification-notice-message-single-line-auto-margin::before {\n    display: block;\n    content: '';\n  }\n  .ant-notification-notice-description {\n    font-size: 14px;\n  }\n  .ant-notification-notice-closable .ant-notification-notice-message {\n    padding-right: 24px;\n  }\n  .ant-notification-notice-with-icon .ant-notification-notice-message {\n    margin-bottom: 4px;\n    margin-left: 48px;\n    font-size: 16px;\n  }\n  .ant-notification-notice-with-icon .ant-notification-notice-description {\n    margin-left: 48px;\n    font-size: 14px;\n  }\n  .ant-notification-notice-icon {\n    position: absolute;\n    margin-left: 4px;\n    font-size: 24px;\n    line-height: 24px;\n  }\n  .anticon.ant-notification-notice-icon-success {\n    color: #52c41a;\n  }\n  .anticon.ant-notification-notice-icon-info {\n    color: #1890ff;\n  }\n  .anticon.ant-notification-notice-icon-warning {\n    color: #faad14;\n  }\n  .anticon.ant-notification-notice-icon-error {\n    color: #ff4d4f;\n  }\n  .ant-notification-notice-close {\n    position: absolute;\n    top: 16px;\n    right: 22px;\n    color: rgba(0, 0, 0, 0.45);\n    outline: none;\n  }\n  .ant-notification-notice-close:hover {\n    color: rgba(0, 0, 0, 0.67);\n  }\n  .ant-notification-notice-btn {\n    float: right;\n    margin-top: 16px;\n  }\n  .ant-notification .notification-fade-effect {\n    -webkit-animation-duration: 0.24s;\n            animation-duration: 0.24s;\n    -webkit-animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n            animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n  }\n  .ant-notification-fade-enter,\n  .ant-notification-fade-appear {\n    -webkit-animation-duration: 0.24s;\n            animation-duration: 0.24s;\n    -webkit-animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n            animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    opacity: 0;\n    -webkit-animation-play-state: paused;\n            animation-play-state: paused;\n  }\n  .ant-notification-fade-leave {\n    -webkit-animation-duration: 0.24s;\n            animation-duration: 0.24s;\n    -webkit-animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n            animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    -webkit-animation-duration: 0.2s;\n            animation-duration: 0.2s;\n    -webkit-animation-play-state: paused;\n            animation-play-state: paused;\n  }\n  .ant-notification-fade-enter.ant-notification-fade-enter-active,\n  .ant-notification-fade-appear.ant-notification-fade-appear-active {\n    -webkit-animation-name: NotificationFadeIn;\n            animation-name: NotificationFadeIn;\n    -webkit-animation-play-state: running;\n            animation-play-state: running;\n  }\n  .ant-notification-fade-leave.ant-notification-fade-leave-active {\n    -webkit-animation-name: NotificationFadeOut;\n            animation-name: NotificationFadeOut;\n    -webkit-animation-play-state: running;\n            animation-play-state: running;\n  }\n  @-webkit-keyframes NotificationFadeIn {\n    0% {\n      left: 384px;\n      opacity: 0;\n    }\n    100% {\n      left: 0;\n      opacity: 1;\n    }\n  }\n  @keyframes NotificationFadeIn {\n    0% {\n      left: 384px;\n      opacity: 0;\n    }\n    100% {\n      left: 0;\n      opacity: 1;\n    }\n  }\n  @-webkit-keyframes NotificationLeftFadeIn {\n    0% {\n      right: 384px;\n      opacity: 0;\n    }\n    100% {\n      right: 0;\n      opacity: 1;\n    }\n  }\n  @keyframes NotificationLeftFadeIn {\n    0% {\n      right: 384px;\n      opacity: 0;\n    }\n    100% {\n      right: 0;\n      opacity: 1;\n    }\n  }\n  @-webkit-keyframes NotificationFadeOut {\n    0% {\n      max-height: 150px;\n      margin-bottom: 16px;\n      opacity: 1;\n    }\n    100% {\n      max-height: 0;\n      margin-bottom: 0;\n      padding-top: 0;\n      padding-bottom: 0;\n      opacity: 0;\n    }\n  }\n  @keyframes NotificationFadeOut {\n    0% {\n      max-height: 150px;\n      margin-bottom: 16px;\n      opacity: 1;\n    }\n    100% {\n      max-height: 0;\n      margin-bottom: 0;\n      padding-top: 0;\n      padding-bottom: 0;\n      opacity: 0;\n    }\n  }\n  .ant-notification-rtl {\n    direction: rtl;\n  }\n  .ant-notification-rtl .ant-notification-notice-closable .ant-notification-notice-message {\n    padding-right: 0;\n    padding-left: 24px;\n  }\n  .ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-message {\n    margin-right: 48px;\n    margin-left: 0;\n  }\n  .ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-description {\n    margin-right: 48px;\n    margin-left: 0;\n  }\n  .ant-notification-rtl .ant-notification-notice-icon {\n    margin-right: 4px;\n    margin-left: 0;\n  }\n  .ant-notification-rtl .ant-notification-notice-close {\n    right: auto;\n    left: 22px;\n  }\n  .ant-notification-rtl .ant-notification-notice-btn {\n    float: left;\n  }\n.home {\n    position: relative;\n    padding: 3% 5% 0 5%;\n    .home-main {\n        width: 100%;\n        height: auto;\n        @include flex(column, nill, center);\n        box-sizing: border-box;\n        @include screen(\"inbetween\") {\n            padding: 5%;\n        }\n        .step-1 {\n            width: 92%;\n            margin-top: 5%;\n            @include flex(row, space-between, center);\n            @include screen(\"inbetween\") {\n                width: 100%;\n                @include flex(column, nill, flex-start);\n                margin-bottom: 8vh;\n            }\n            #topic{\n                width: 28%;\n                margin-left: 2.5%;\n                @include fonts(32, 50, 800);\n                @include screen(\"inbetween\") {\n                    width: 100%;\n                    margin: 0 0 5vh 0;\n                    @include fonts(24, 30, 800);\n                    text-align: center;\n                }\n            }\n            .locker{\n                background: rgba(255, 255, 255, 0.05);\n                box-shadow: 0px 14px 40px rgba(0, 0, 0, 0.1);\n                border-radius: 8px;\n                padding: 1.5vh 2vw;\n                @include flex(row, center, flex-start);\n                box-sizing: border-box;\n                @include screen(\"inbetween\") {\n                    width: 80%;\n                    margin: 0 auto;\n                }\n                .lock-left{\n                    margin-right: 3.5vw;\n                    #title{\n                        @include fonts(13, 20, bold);\n                        margin-bottom: 1.5vh;\n                    }\n                    #value{\n                        @include fonts(24, 30, 600);\n                    }\n                }\n            }\n        }\n\n        .step-2{\n            width: 92%;\n            margin-top: 5%;\n            padding: 2vw;\n            box-sizing: border-box;\n            background: rgba(255, 255, 255, 0.05);\n            box-shadow: 0px 14px 40px rgba(0, 0, 0, 0.1);\n            border-radius: 8px;\n            @include screen(\"inbetween\") {\n                width: 100%;\n                margin-bottom: 8vh;\n                padding: 5vw;\n                box-sizing: border-box;\n            }\n            #connect{\n                @include fonts(24, 30, 500);\n                text-align: center;\n            }\n            #dets{\n                @include fonts(14, 30, 500);\n                text-align: center;\n                color: #8E93A4;\n            }\n\n            .non-empty {\n                width: 100%;\n                @include flex(row, space-between, center);\n                @include screen(\"inbetween\") {\n                    @include flex(column, nill, flex-start);\n                }\n                .left-2{\n                    @include flex(row, nill, center);\n                    @include screen(\"inbetween\") {\n                        @include flex(column, nill, flex-start);\n                        margin-bottom: 5vh;\n                    }\n                    .box-2{\n                        margin-right: 5vw;\n                        @include screen(\"inbetween\") {\n                            margin: 0 0 5vh 0;\n                        }\n                        .prop{\n                            color: #8E93A4;\n                            @include fonts(14, 20, 500);\n                            margin-bottom: 2vh;\n                            @include screen(\"inbetween\") {\n                                margin-bottom: 1vh;\n                                @include fonts(12, 20, 500);\n                            }\n                        }\n                        .val{\n                            @include fonts(24, 30, bold);\n                            @include screen(\"inbetween\") {\n                                @include fonts(18, 25, bold);\n                            }\n                        }\n                        .amount{\n                            @include fonts(14, 20, 500);\n                            @include screen(\"inbetween\") {\n                                @include fonts(12, 20, 500);\n                            }\n                        }\n                    }\n                }\n                .right-2{\n                    align-self: flex-end;\n                    @include flex(row, nill, center);\n                    @include screen(\"inbetween\") {\n                        align-self: flex-start;\n                        width: 100%;\n                        @include flex(row, space-between, center);\n                    }\n                    .pointer{\n                        @include flex(row, nill, center);\n                        cursor: pointer;\n                        margin-right: 2.5vw;\n                        .label{\n                            margin-right: 0.5vw;\n                            @include fonts(14, 20, 500);\n                        }\n                    }\n                }\n            }\n        }\n\n        .step-3 {\n            width:  92%;\n            height: auto;\n            margin-top: 5%;\n            @include flex(row, space-between, center);\n            @include screen(\"inbetween\") {\n                @include flex(column, nill, flex-start);\n            }\n        }\n    }\n}\n","\n//////// Packages card ///// \n.package-card {\n    width: 31%;\n    min-height: 30vh;\n    border-radius: 8px;\n    padding: 2.5%;\n    box-sizing: border-box;\n    @include screen(\"inbetween\") {\n        width: 100%;\n        padding: 5%;\n        margin-bottom: 5vh;\n    }\n    background: rgba(255, 255, 255, 0.05);\n    box-shadow: 0px 14px 40px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    .card-type-desc{\n        font-family: Fira Sans;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 143%;\n    display: flex;\n    align-items: center;\n    color: #8E93A4;\n    }\n    .card-type{\n        @include fonts(18, 20, 500);\n        margin-bottom: 2.5vh;\n        font-family: Fira Sans;\n       font-style: normal;\n       font-weight: 500;\n        @include screen(\"inbetween\") {\n            @include fonts(15, 20, 500);\n        }\n    }\n    .card-apy{\n        @include fonts(81, 90, 600);\n        margin-bottom: 10%;\n        @include screen(\"inbetween\") {\n            @include fonts(50, 70, 600);\n        }\n        #apy{\n            @include fonts(18, 20, 500);\n            @include screen(\"inbetween\") {\n                @include fonts(15, 20, 500);\n            }\n        }\n    }\n}\n\n.containerBanner{\n    position: relative;\n    text-align: center;\n   \n}\n\n.top-left-banner{\n    position: absolute;\n    top: 10vh;\n    left: 8vw;\n    font-family: Fira Sans;\nfont-style: normal;\nfont-weight: bold;\nfont-size: 18.4612px;\nline-height: 143%;\n/* or 26px */\n\n\ncolor: #FDFDFD;\n}\n\n.banner-img{\n    @media only screen and (min-width: 600px)  {\n\t\twidth: 60vw;\n\t}\n\t@media screen  and (max-width: 400px){\n        width: 82vw;\n\t}\n\n    @media screen  and (max-width: 768px){\n        width: 80vw;\n\t}\n    \n}\n.centered-banner {\n    @media only screen and (min-width: 600px)  {\n        position: absolute;\n        top: 20vh;\n        left: 53vw;\n        transform: translate(-50%, -50%);\n        background-color: #E46D28;\n\t}\n\t@media screen  and (min-height: 812px) and (max-width: 813px) {\n        position: absolute;\n    top: 10vh;\n    left: 71vw;\n    transform: translate(-50%, -50%);\n    background-color: #E46D28;\n    height: 14px;\n\t}\n\n    @media screen  and (min-width: 375px) and (max-width: 376px) {\n        position: absolute;\n    top: 7vh;\n    left: 71vw;\n    transform: translate(-50%, -50%);\n    background-color: #E46D28;\n    height: 23px;\n\t}\n\n    @media screen  and (min-width: 414px) and (max-width: 415px) {\n        position: absolute;\n    top: 7vh;\n    left: 71vw;\n    transform: translate(-50%, -50%);\n    background-color: #E46D28;\n    height: 14px;\n\t}\n    @media screen  and (min-width: 411px) and (max-width: 412px) {\n        position: absolute;\n    top: 7vh;\n    left: 71vw;\n    transform: translate(-50%, -50%);\n    background-color: #E46D28;\n    height: 14px;\n\t}\n\n    @media screen  and (max-width: 360px){\n        position: absolute;\n    top: 7vh;\n    left: 72vw;\n    transform: translate(-50%, -50%);\n    background-color: #E46D28;\n    height: 14px;\n\t}\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    // @media screen  and (max-width: 768px){\n    //     position: absolute;\n    // top: 10vh;\n    // left: 70vw;\n    // transform: translate(-50%, -50%);\n    // background-color: #E46D28;\n\t// }\n    @media only screen \n    and (min-device-width: 768px) \n    and (max-device-width: 1024px) \n    and (orientation: portrait) \n    and (-webkit-min-device-pixel-ratio: 2) {\n        position: absolute;\n            top: 8vh;\n            left: 53vw;\n            transform: translate(-50%, -50%);\n            background-color: #E46D28;\n  }\n\n   \n  }\n\n  .arrowClassBanner{\n    @media only screen and (min-width: 600px)  {\n        height: 3vh;\n\t}\n\t@media screen and (min-width: 375px) and (max-width: 400px){\n        height: 1vh;\n\t}\n\n    @media screen  and (min-width: 360px) and (max-width: 361px){\n        height: 2vh;\n\t}\n    @media only screen \n    and (min-device-width: 768px) \n    and (max-device-width: 1024px) \n    and (orientation: portrait) \n    and (-webkit-min-device-pixel-ratio: 2) {\n        height: 2vh;\n  }\n    // @media screen  and (max-width: 768px){\n    //     height: 2vh;\n\t// }\n    // @media screen  and (max-width: 1024px){\n    //     height: 2vh;\n\t// }\n  \n  }\n.bottom-right-banner {\n    position: absolute;\n    bottom: 20vh;\n    right: 14vw;\n    font-family: Fira Sans;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 18.4612px;\n    line-height: 143%;\n    width: 10vw;\n    color: #FFFFFF;\n    width: 200px;\n    height: 57px;\n/* or 19px */\n\n\ncolor: #FFFFFF;\n  }\n\n\n////// Footer //////// \nfooter {\n    @include flex(row, space-between, center);\n    margin-top: auto;\n    padding: 5% 5% 2% 5%;\n    box-sizing: border-box;\n    @include screen(\"inbetween\") {\n        flex-direction: column;\n        align-items: flex-start;\n        margin-bottom: 0.5vh;\n    }\n    #copy{\n        order: 1;\n        @include fonts(12, 14, 500);\n        color: #D1D1D1;\n        @include screen(\"inbetween\") {\n            order: 2;\n        }\n    }\n    .foot-menu{\n        order: 2;\n        @include flex(row, nill, center);\n        list-style: none;\n        margin: 0;\n        padding: 0;\n        @include screen(\"inbetween\") {\n            order: 1;\n        }\n        .foot-list{\n            margin: 0 2vw 1vh 0;\n            @include fonts(14, 17, 500);\n            cursor: pointer;\n        }\n    \n    }\n}\n","\n.table-cont {\n\tbox-shadow: 0px 0px 17px rgba(0, 0, 0, 0.08);\n\tborder-radius: 6px;\n\tposition: relative;\n\t.table-scroll {\n\t\tposition: relative;\n\t\t@include screen(\"inbetween\") {\n\t\t\toverflow: auto;\n\t\t}\n\t}\n\ttable {\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\tpadding: 1rem;\n        border-collapse: collapse;\n\n\t\tthead {\n\t\t\theight: 4.06rem;\n\t\t\tz-index: 100;\n            \n\t\t\ttr {\n\t\t\t\theight: 10vh;\n                \n\t\t\t\tth {\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tmargin-bottom: 10rem;\n                    @include fonts(14, 20, bold);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\ttbody {\n\t\t\toverflow: scroll;\n\t\t\tmargin-top: 30vh;\n            background: rgba(255, 255, 255, 0.05);\n            box-shadow: 0px 14px 40px rgba(0, 0, 0, 0.1);\n            border-radius: 30px;\n\t\t\tmin-height: 50vh;\n            \n\t\t\ttr {\n\t\t\t\theight: 10vh;\n                border-bottom: 1px solid rgba(102, 102, 102, 0.91);\n\t\t\t\tpadding: 0.2vh 0;\n\t\t\t}\n\t\t\ttr:last-child {\n\t\t\t\tborder-bottom: none;\n\t\t\t}\n            td{\n                @include fonts(14, 20, bold);\n            }\n\t\t}\n\t\tth {\n\t\t\ttext-align: left;\n\t\t\tpadding-left: 2.81rem;\n\t\t}\n\t\ttd {\n\t\t\tpadding-left: 2.81rem;\n\t\t}\n\t\t@include screen(\"small\") {\n\t\t\tth {\n\t\t\t\tpadding: 0.937rem;\n\t\t\t\twhite-space: nowrap;\n\t\t\t}\n\t\t\ttd {\n\t\t\t\tpadding: 0.937rem;\n\t\t\t\twhite-space: nowrap;\n\t\t\t}\n\t\t}\n\t}\n\t.empty-cont {\n\t\tmin-height: 40vh;\n\t\tpadding: 2.5rem;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground-color: rgba(48, 47, 47, 0.14);\n\t\tcolor: #FF6600;\n\t\tbox-sizing: border-box;\n\t}\n\t.pagination {\n\t\tbackground-color: #fff;\n\t\tpadding: 2rem 3rem;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\toverflow-x: scroll;\n\t\t.pages {\n\t\t\toverflow-x: scroll;\n\t\t\t.page {\n\t\t\t\tmargin: 0 0.09rem;\n\t\t\t\tborder-radius: 2px;\n\t\t\t\ttext-align: center;\n\t\t\t\tpadding: 0.15rem 0.3rem;\n\t\t\t\tcolor: #c7c7c7;\n\t\t\t\tborder: 1px solid pink;\n\t\t\t\t&.ellipse {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tborder: 0;\n\t\t\t\t\tpadding: 0.15rem 0;\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\tbackground-color: pink;\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t}\n\t\t\t}\n\t\t\timg {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\t\t}\n\t}\n}\n\n#table-user{\n\t@include flex(row, nill, center);\n\ttext-transform: capitalize;\n\tpadding: 0.7vh;\n\t\timg{\n\t\tmargin-right: 0.5vw;\n\t}\n}\n#red-status{\n\t@include fonts(18, 23, 500);\n\ttext-transform: capitalize;\n\tcolor: #E8433D;\n}\n#green-status{\n\t@include fonts(18, 23, 500);\n\ttext-transform: capitalize;\n\tcolor: #23A65A;\n}\n\n\n","\n.transactions{\n    padding: 3% 5% 0 5%;\n    .transaction-main{\n        margin-top: 5vh;\n        .header{\n            @include flex(row, nill, center);\n            .back-img{\n                margin-right: 1.5vw;\n                cursor: pointer;\n                @include screen(\"inbetween\") {\n                    margin-right: 3vw;\n                }\n            }\n            .page-dets{\n                #topic{\n                    @include fonts(24, 30, 800);\n                    @include screen(\"inbetween\") {\n                        @include fonts(18, 20, 800);\n                    }\n                }\n                #sub-topic{\n                    @include fonts(14, 17, 500);\n                    @include screen(\"inbetween\") {\n                        @include fonts(12, 15, 500);\n                    }\n                }\n            }\n        }\n        .table-section{\n            margin-top: 5vh;\n        }\n    }\n}\n","\n.filter{\n    &.stake-filter{\n        margin-top: 5vh;\n    }\n    .label{\n        width: 100%;\n        @include fonts(14, 17, 500);\n        display: flex;\n        align-items: center;\n        // color: #000000;\n        margin: 0 0 0.5rem 0;\n        @include flex(row, nill, flex-start);\n    \n        .asterik{\n          display: block;\n          margin-left: 0.2vw;\n          color: #FF6600;\n        }\n        .hide{\n          display: none;\n        }\n      }\n    .select{\n        width: 100%;\n        padding: 0 1.5vw;\n        display: flex;\n        justify-content: center;\n        height: 2.8rem;\n        outline: none;\n        box-sizing: border-box;\n        border-radius: 7px;\n        font-style: normal;\n        @include fonts(14, 17, normal);\n        // font-weight: 600;\n        // font-size: 0.812rem;\n        cursor: pointer;\n        background-color: transparent;\n        color: #F9F9F9;\n        // background: linear-gradient(44.25deg, #E8433D 25.64%, #FF6600 53.43%);\n        // -webkit-background-clip: text;\n        // -webkit-text-fill-color: transparent;\n    }\n    &.ship-filter-long{\n        width: 100%;\n        margin-bottom: 1.5rem;\n        .select{\n            border: 1px solid #707070;\n            height: 3rem;\n            @include fonts(18, 23, bold);\n            color: #6D6D6D;\n            background: none;\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: #6D6D6D;\n        }\n    }\n}\n","\n\n@import \"./mixins.scss\";\n@import \"./screens.scss\";\n\n.input-box {\n  width: 100%;\n  @include flex(column, nill, nill);\n  margin-bottom: 1rem;\n  &.stake-input{\n    margin-top: 5vh;\n  }\n  &.stake-type{\n    margin-top: 5vh;\n  }\n\n  .head-box{\n    @include flex(row, space-between, center);\n    width: 100%;\n    .label-box{\n      justify-self: flex-start;\n      width: 100%;\n      .label{\n        width: 100%;\n        @include fonts(14, 17, 500);\n        display: flex;\n        align-items: center;\n        // color: #000000;\n        margin: 0 0 0.5rem 0;\n        @include flex(row, nill, flex-start);\n    \n        .asterik{\n          display: block;\n          margin-left: 0.2vw;\n          color: #FF6600;\n        }\n        .hide{\n          display: none;\n        }\n      }\n      .sub-label{\n        // color: #6D6D6D;\n        @include fonts(13, 17, 500);\n        margin-bottom: 0.4rem;\n      }\n    }\n    .input-right{\n      justify-self: flex-end;\n    }\n  }\n  \n  .input-cont{\n    width: 100%;\n    border: 1px solid #707070;\n    box-sizing: border-box;\n    border-radius: 7px;\n    height: 3rem;\n    @include flex(row, space-between, center);\n    margin-bottom: 1rem;\n    @include screen(\"inbetween\") {\n      height: 3rem;\n    }\n\n    .input{\n      width: 100%;\n      @include flex(row, nill, center);\n      height: 100%;\n      border: none;\n      box-sizing: border-box;\n      border-radius: 60px;\n      padding: 0 5%;\n      @include fonts(14, 17, normal);\n      display: flex;\n      align-items: center;\n      outline: none;\n      background: transparent;\n      color: #FFFFFF;\n      @include screen(\"inbetween\") {\n        width: 100%;\n        @include fonts(15, 21, bold);\n      }\n      &.stake-type{\n        text-align: center;\n        @include fonts(18, 22, normal);\n      }\n    }\n    .suffix{\n      width: 35%;\n      height: 100%;\n      box-sizing: border-box;\n      @include flex(row, center, center);\n      border-left: 0.5px solid #6D6D6D;\n      @include screen(\"inbetween\") {\n        width: 45%;\n      }\n    \n  }\n  \n  &.step-input{\n    border: 2px solid #FF6600;\n      input{\n        width: 65%;\n        color: #1F1F20;\n      }\n      .suffix{\n        width: 35%;\n      }\n    @include screen(\"inbetween\") {\n      .input-cont{\n        input{\n          width: 60%;\n        }\n        .suffix{\n          width: 40%;\n        }\n      }\n    }\n  }\n}\n\n\n  ///// label component //////\n  .label-cont{\n    @include flex(row, space-between, center);\n    padding: 0 2vw;\n    box-sizing: border-box;\n    width: 100%;\n    #label-text{\n      @include fonts(18, 23, bold);\n      // color: #6D6D6D;\n      @include screen(\"inbetween\") {\n        @include fonts(14, 20, bold);\n    }\n    }\n    .label-right{\n      @include flex(row, nill, center);\n      p{\n        @include flex(row, nill, center);\n        #available{\n          @include fonts(12, 20, normal);\n          // color: #6D6D6D;\n        }\n        #coin{\n          @include fonts(12, 20, bold);\n          margin-left: 0.3vw;\n        }\n        #max{\n          background: #f3dbca;\n          @include fonts(12, 16, bold);\n          color: #FF6600;\n          padding: 0.6vw 0.5vw;\n          border-radius: 100px;\n          margin-left: 1vw;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n\n  .trasnaction-suffix{\n    width: 80%;\n    @include flex(row, space-between, center);\n    #arrow{\n      cursor: pointer;\n    }\n  }\n\n  .step-suffix{\n    width: 90%;\n    @include flex(row, space-around, center);\n    @include screen(\"inbetween\") {\n      width: 90%;\n    }\n    #coin{\n      @include screen(\"inbetween\") {\n        width: 3vw;\n        height: 3vh;\n      }\n    }\n    #currency{\n      @include fonts(15, 23, bold);\n      @include screen(\"inbetween\") {\n        @include fonts(12, 20, bold);\n      }\n    }\n  }\n}\n\n.input-label{\n  width: 100%;\n  @include flex(row, space-between, center);\n  #label-right{\n    color: #B1AFCD;\n    @include fonts(10, 12, 500);\n    #suffix-span{\n      margin-left: 0.5vw;\n    }\n  }\n}\n\n","\n.staking{\n    width: 100%;\n    height: 100%;\n    @include flex(row, nill, nill);\n    @include screen(\"inbetween\") {\n        flex-direction: column;\n    }\n    .stake-title{\n        @include fonts(18, 22, 500);\n        margin-bottom: 5vh;\n    }\n\n    .stake-left{\n        width: 50%;\n        border-right: 1px solid rgba(216, 216, 216, 0.05);\n        @include screen(\"inbetween\") {\n            width: 100%;\n            padding: 5%;\n            box-sizing: border-box;\n            border-right: none;\n        }\n        .left-main{\n            padding: 1.5vw 2vw;\n            box-sizing: border-box;\n        }\n        \n    }\n\n\n    .percentages {\n        margin: 1.5rem 20% 1rem;\n        display: flex;\n        -webkit-box-align: center;\n        align-items: center;\n        -webkit-box-pack: justify;\n        justify-content: space-between;\n    }\n\n    .activeValueSelection{\n        border: 2px solid rgb(255, 102, 0);\n    border-radius: 40.8111px;\n    padding: 0.3rem 0.7rem;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    color: rgb(255, 102, 0);\n    }\n    .notActiveValueSelection{\n        font-style: normal;\n        font-weight: 600;\n        font-size: 14px;\n        color: rgb(255, 102, 0);\n        cursor: pointer;\n    }\n    \n\n    .stake-right{\n        width: 50%;\n        padding: 1.5vw 2vw 3vw 2vw;\n        box-sizing: border-box;\n        @include screen(\"inbetween\") {\n            width: 100%;\n            padding: 5%;\n            box-sizing: border-box;\n        }\n        .box{\n            margin-top: 3vh;\n            min-height: 20vh;\n            margin-bottom: 3vh;\n            @include flex(row, nill, nill);\n            .rings{\n                margin-right: 1vw;\n            }\n            .items-main{\n                width: 100%;\n                min-height: 100%;\n                @include flex(column, space-between, nill);\n                .row{\n                    // margin-bottom: 5vh;\n                    @include flex(row, space-between, center);\n                    .item{\n                        color: #B1AFCD;\n                    }\n                    .val{\n                        color: rgba(177, 175, 205, 0.5);\n                    }\n                }\n            }\n        }\n        .row-box{\n            @include flex(row, space-between, center);\n            margin-bottom: 3vh;\n            #item{\n                color: #B1AFCD;\n            }\n            #val{\n                color: #16AB5B;\n            }\n        }\n        .check{\n            @include flex(row, nill, center);\n            margin: 5vh 0;\n            .check-img{\n                margin-right: 1vw;\n            }\n            #agree{\n                color: rgba(177, 175, 205, 0.5);\n            }\n        }\n    }\n}\n",".ant-notification {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5715;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: fixed;\n  z-index: 1010;\n  margin-right: 24px;\n}\n.ant-notification-topLeft,\n.ant-notification-bottomLeft {\n  margin-right: 0;\n  margin-left: 24px;\n}\n.ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active,\n.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active {\n  -webkit-animation-name: NotificationLeftFadeIn;\n          animation-name: NotificationLeftFadeIn;\n}\n.ant-notification-close-icon {\n  font-size: 14px;\n  cursor: pointer;\n}\n.ant-notification-hook-holder {\n  position: relative;\n}\n.ant-notification-notice {\n  position: relative;\n  width: 384px;\n  max-width: calc(100vw - 24px * 2);\n  margin-bottom: 16px;\n  margin-left: auto;\n  padding: 16px 24px;\n  overflow: hidden;\n  line-height: 1.5715;\n  word-wrap: break-word;\n  background: #fff;\n  border-radius: 2px;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n}\n.ant-notification-topLeft .ant-notification-notice,\n.ant-notification-bottomLeft .ant-notification-notice {\n  margin-right: auto;\n  margin-left: 0;\n}\n.ant-notification-notice-message {\n  margin-bottom: 8px;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 16px;\n  line-height: 24px;\n}\n.ant-notification-notice-message-single-line-auto-margin {\n  display: block;\n  width: calc(384px - 24px * 2 - 24px - 48px - 100%);\n  max-width: 4px;\n  background-color: transparent;\n  pointer-events: none;\n}\n.ant-notification-notice-message-single-line-auto-margin::before {\n  display: block;\n  content: '';\n}\n.ant-notification-notice-description {\n  font-size: 14px;\n}\n.ant-notification-notice-closable .ant-notification-notice-message {\n  padding-right: 24px;\n}\n.ant-notification-notice-with-icon .ant-notification-notice-message {\n  margin-bottom: 4px;\n  margin-left: 48px;\n  font-size: 16px;\n}\n.ant-notification-notice-with-icon .ant-notification-notice-description {\n  margin-left: 48px;\n  font-size: 14px;\n}\n.ant-notification-notice-icon {\n  position: absolute;\n  margin-left: 4px;\n  font-size: 24px;\n  line-height: 24px;\n}\n.anticon.ant-notification-notice-icon-success {\n  color: #52c41a;\n}\n.anticon.ant-notification-notice-icon-info {\n  color: #1890ff;\n}\n.anticon.ant-notification-notice-icon-warning {\n  color: #faad14;\n}\n.anticon.ant-notification-notice-icon-error {\n  color: #ff4d4f;\n}\n.ant-notification-notice-close {\n  position: absolute;\n  top: 16px;\n  right: 22px;\n  color: rgba(0, 0, 0, 0.45);\n  outline: none;\n}\n.ant-notification-notice-close:hover {\n  color: rgba(0, 0, 0, 0.67);\n}\n.ant-notification-notice-btn {\n  float: right;\n  margin-top: 16px;\n}\n.ant-notification .notification-fade-effect {\n  -webkit-animation-duration: 0.24s;\n          animation-duration: 0.24s;\n  -webkit-animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n          animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n}\n.ant-notification-fade-enter,\n.ant-notification-fade-appear {\n  -webkit-animation-duration: 0.24s;\n          animation-duration: 0.24s;\n  -webkit-animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n          animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  opacity: 0;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.ant-notification-fade-leave {\n  -webkit-animation-duration: 0.24s;\n          animation-duration: 0.24s;\n  -webkit-animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n          animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-fade-appear.ant-notification-fade-appear-active {\n  -webkit-animation-name: NotificationFadeIn;\n          animation-name: NotificationFadeIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.ant-notification-fade-leave.ant-notification-fade-leave-active {\n  -webkit-animation-name: NotificationFadeOut;\n          animation-name: NotificationFadeOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n@-webkit-keyframes NotificationFadeIn {\n  0% {\n    left: 384px;\n    opacity: 0;\n  }\n  100% {\n    left: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationFadeIn {\n  0% {\n    left: 384px;\n    opacity: 0;\n  }\n  100% {\n    left: 0;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes NotificationLeftFadeIn {\n  0% {\n    right: 384px;\n    opacity: 0;\n  }\n  100% {\n    right: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationLeftFadeIn {\n  0% {\n    right: 384px;\n    opacity: 0;\n  }\n  100% {\n    right: 0;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes NotificationFadeOut {\n  0% {\n    max-height: 150px;\n    margin-bottom: 16px;\n    opacity: 1;\n  }\n  100% {\n    max-height: 0;\n    margin-bottom: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    opacity: 0;\n  }\n}\n@keyframes NotificationFadeOut {\n  0% {\n    max-height: 150px;\n    margin-bottom: 16px;\n    opacity: 1;\n  }\n  100% {\n    max-height: 0;\n    margin-bottom: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    opacity: 0;\n  }\n}\n.ant-notification-rtl {\n  direction: rtl;\n}\n.ant-notification-rtl .ant-notification-notice-closable .ant-notification-notice-message {\n  padding-right: 0;\n  padding-left: 24px;\n}\n.ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-message {\n  margin-right: 48px;\n  margin-left: 0;\n}\n.ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-description {\n  margin-right: 48px;\n  margin-left: 0;\n}\n.ant-notification-rtl .ant-notification-notice-icon {\n  margin-right: 4px;\n  margin-left: 0;\n}\n.ant-notification-rtl .ant-notification-notice-close {\n  right: auto;\n  left: 22px;\n}\n.ant-notification-rtl .ant-notification-notice-btn {\n  float: left;\n}\n// .notification-box {\n//   position: fixed;\n//   left:45vw;\n//   top:50%;\n//   display: flex;\n//   justify-content: center;\n//   align-items: center;\n//   background-color: white;\n//   color:#333;\n//   //padding:10px;\n//   font-size: 16px;\n//   max-width: 250px;\n//   box-sizing: border-box;\n//   overflow: hidden;\n//   z-index: 25;\n//   box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n//   transition: all 300ms ease-in-out;\n// }\n\n// .w2 { width: 120px; }\n\n// .notification-box .success {\n//   color: green;\n// }\n\n// .notification-box .warning {\n//   color: orange\n// }\n\n// .notification-box .error {\n//   color: red;\n// }\n\n// .notification-box .info {\n//   color: #007bff;\n// }\n","\n.AddressContainer{\n\tdisplay: flex;\n\talign-items: center;\n\n\t& > div {\n\t\tborder: 1px solid  rgba(241, 237, 237, 0.6);;\n\t\tbox-sizing: border-box;\n\t\tflex-grow: 1;\n\t\tborder-radius: 34px;\n\t\tpadding: 16px;\n\t\tdisplay: flex;\n\t\tmargin-right: 16px;\n\t\toverflow-x: auto;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\t\n\t\t& > p {\n\t\t\tmargin: 0;\n\t\t\tcolor: rgba(241, 237, 237, 0.6);\n\t\t}\n\t}\n}\n\n.ConnectInfoWrapper{\n\tdisplay: flex;\n\tmargin-bottom: 60px;\n\n\t& > div {\n\t\theight: 48px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tflex: auto;\n\t\tjustify-content: space-between;\n\t}\n}\n\n.InfoWrapper{\n\tpadding: 28px;\n\tbackground:#27282C;\n\tborder-radius: 6px;\n\tcolor: #edecec;\n\tfont-size: 20px;\n\tfont-weight: 600;\n\tline-height: 138%;\n}\n\n.SectionWrapper{\n\tmargin-top: 40px;\n}\n\n.SectionBodyNetwork{\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-bottom: 16px;\n\n\t@media (min-width: 768px){\n\t\tflex-direction: row;\n\t\t\n\t}\n}\n\n.CardWrapper{\n\tcursor: pointer;\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tmargin-bottom: 10px;\n\tmargin-right: 10px;\n  \theight: 90px;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tbackground: #27282C;\n\tborder: 1px solid rgba(0, 0, 0, 0.06);\n\tbox-sizing: border-box;\n\tbox-shadow: 0px 3.51724px 36.0517px rgba(0, 0, 0, 0.06);\n\tborder-radius: 14.7847px;\n\tpadding: 16px;\n\n\t&:disabled {\n\t\tcursor: not-allowed;\n\t\topacity: 0.5;\n\t\tbackground:#edecec;\n\t}\n\n\t@media (min-width: 768px){\n\t\twidth: 33%;\n\t}\n\n\t& .chain-name {\n\t\tmargin-left: 16px;\n\t\tcolor: #edecec;\n\t}\n\n\t& .apy {\n\t\tcolor: #edecec;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t}\n\n\t& .check {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\ttransform: translate(30%, -30%);\n\t}\n}\n\n.SectionHeader{\n\tdisplay: flex;\n\tmargin: 16px 0px;\n\talign-items: center;\n\n\t& .number {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\theight: 26px;\n\t\twidth: 26px;\n\t\tbackground: rgba(0, 0, 0, 0.06);\n\t\tcolor:#edecec;\n\t\tfont-weight: 600;\n\t\tfont-size: 18px;\n\t\tborder-radius: 50%;\n\t\tcolor:#edecec;\n\t}\n\n\t& .modal-title {\n\t\tfont-weight: 600;\n\t\tfont-size: 18px;\n\t\tmargin-left: 20px;\n\t\tcolor:#edecec;\n\t}\n}\n\n.ModalControls{\n\twidth: 100%;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #e6e6e6;\n    padding-bottom: 20px;\n    margin-bottom: 5vw;\n    & .heading {\n        font-weight: 600;\n        font-size: 1.5rem;\n        margin-bottom: 5px;\n        text-transform: capitalize;\n        color:#edecec;\n    }\n\n    & .desc {\n        font-size: 1rem;\n        color: #edecec;\n    }\n\n    & > div:first-child {\n        flex: 1;\n        color:#edecec;\n    }\n\n    & button.close {\n        border: none;\n        height: 50px;\n        width: 50px;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #5e5656 !important;\n        cursor: pointer;\n\n    }\n\n        & .close-btn {\n            color: #edecec;\n        }\n}\n\n.ConnectWalletStyle{\n\tborder: none;\n\tmargin-left: 15px;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground: linear-gradient(100.89deg,  #363535 3.11%, #9d9c9c 122.62%);;\n\tmin-width: max-content;\n\tmax-height: 46px;\n\tborder-radius: 38px;\n\tcolor: white;\n\tpadding: 10px;\n\tfont-weight: 600;\n\tfont-size: 12px;\n\tcursor: pointer;\n\n\t& > div {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t}\n\n\t& .wallet {\n\t\tbackground-color: rgba(255, 255, 255, 0.2);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 0px;\n\t\tborder-radius: 52px;\n\t\tmargin-left: 10px;\n\t}\n\n\t& figure {\n\t\tmargin-right: 7px;\n\t\tbackground: transparent;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder-radius: 50%;\n\n\t\t& svg {\n\t\t\twidth: 18px;\n\t\t}\n\t}\n\n\t& figure.connected {\n\t\tbackground: white;\n\t}\n\n\t\n\n\t& figure.connectedNetwork {\n\t\tbackground: white;\n\t\twidth: 40px;\n        height:40px;\n\t}\n\n\t@media (min-width: 900px) {\n\t\tpadding: 10px;\n\t\tbackground: linear-gradient(\n\t\t\t100.89deg,  #363535 3.11%, #9d9c9c 122.62%);\n\t\tfont-size: 14px;\n\n\t\t& .wallet figure {\n\t\t\t& img {\n\t\t\t\twidth: 18px;\n\t\t\t}\n\t\t}\n\t}\n\n\t@media (min-width: 300px) {\n\t\tpadding: 10px;\n\t\tbackground: linear-gradient(\n\t\t\t100.89deg, #363535 3.11%, #9d9c9c 122.62%);\n\t\tfont-size: 14px;\n\n\t\t& .wallet figure {\n\t\t\t& img {\n\t\t\t\twidth: 18px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.CardContainer{\n\tmargin-top: 32px;\n\tborder: 1px solid  rgba(241, 237, 237, 0.6);\n\tbox-sizing: border-box;\n\tbox-shadow: 0px 3.51724px 36.0517px rgba(0, 0, 0, 0.06);\n\tborder-radius: 14.7847px;\n\tpadding: 24px;\n}\n\n.AddressInfoWrapper{\n\tmargin: 8px 0;\n\n\t& p {\n\t\tmargin-bottom: 16px;\n\t}\n}\n\n\n.ActionContainer{\n  display: flex;\n\tflex-direction: column;\n\tpadding: 20px;\n\n\t& div {\n\t\tcursor: pointer;\n\t\tdisplay: flex;\n\t\talign-items: center; \n\t\tmargin-bottom: 10px;\n\n\t\t& p {\n\t\t\tmargin-left: 8px\n\t\t}\n\t}\n\n\t@media (min-width: 768px){\n\t\tflex-direction: row;\n\t\tjustify-content: space-between;\n\t}\n}\n\n\n\n//$defaultWidth: 1vw == 1%; \n.modal-cont-connect {\n\tposition: relative;\n\toverflow-y: auto;\n\tpadding: 30px;\n\twidth: 100%; \n\t//max-width: if($defaultWidth > 720,50vw,75vw);\n\n\tmargin: auto;\n\t/* margin-top: 100px; */\n\tborder-radius: 30px;\n\tmin-height: 50vh;\n\t/* opacity: 0; */\n\ttransform: scale(0.8);\n\ttransition: all 300ms ease;\n\t/* background:#1C1D21; */\n\t@media only screen and (min-width: 600px)  {\n\t\tmax-width: 50vw;\n\t}\n\t@media screen  and (max-width: 350px){\n\t\tmax-width: 75vw;\n\t}\n\n\t\n\t\n\t\n\tbox-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
